{
  "_meta.name": "Türkçe",
  "_meta.dir": "ltr",
  "app.title": "CenterOS Ajan V2",
  "boot.loading": "Oturum açılıyor…",
  "boot.failed": "Oturum açılamadı",
  "nav.agents": "AI Ajanları",
  "nav.studio": "Stüdyo",
  "nav.assets": "Asset'ler",
  "nav.tests": "Test & Karne",
  "nav.conversations": "Görüşmeler",
  "nav.telephony": "Telefon numaraları",
  "nav.usage": "Kullanım",
  "nav.soon": "yakında",
  "agents.title": "AI Ajanları",
  "agents.empty": "Henüz ajan yok. Stüdyo ile ilk ajanınızı oluşturun.",
  "agents.new": "AI ile yeni ajan",
  "agents.col.name": "Ajan",
  "agents.col.direction": "Yön",
  "agents.col.status": "Durum",
  "direction.outbound": "Giden",
  "direction.inbound": "Gelen",
  "direction.both": "Gelen + giden",
  "status.draft": "Taslak",
  "status.published": "Yayında",
  "status.archived": "Arşiv",
  "studio.title": "Stüdyo",
  "studio.subtitle": "Ajanınızı sohbet ederek oluşturun. Markanızın Business Brain bilgisi hazır.",
  "studio.start": "Yeni oturum başlat",
  "studio.starting": "Business Brain okunuyor…",
  "studio.placeholder": "Cevabınızı yazın…",
  "studio.send": "Gönder",
  "studio.thinking": "Düşünüyor…",
  "studio.draft": "Taslak",
  "studio.missing": "Eksik",
  "studio.filled": "Tamam",
  "studio.progress": "{done}/{total} alan",
  "studio.propose": "Taslağı gözden geçir",
  "studio.approve": "Onayla ve ajanı oluştur",
  "studio.approved": "Ajan oluşturuldu. Sıradaki adım: satış asset'leri.",
  "studio.review": "Gözden geçirme",
  "error.generic": "Bir hata oluştu",
  "error.UNAUTHENTICATED": "Oturum süresi doldu, yeniden giriş yapın.",
  "error.HOST_IDENTITY_MISSING": "Panaryus hesabınız bu çalışma alanına bağlı değil.",
  "error.BRAIN_NOT_FOUND": "Yayınlanmış bir işletme bilgi kaynağı bulunamadı.",
  "error.STUDIO_INCOMPLETE": "Önce eksik alanları tamamlayın.",
  "error.STUDIO_LLM_BAD_OUTPUT": "Asistan cevap üretemedi, tekrar deneyin.",
  "error.STUDIO_INVALID_VALUES": "Bazı değerler anlaşılamadı, biraz daha açık yazar mısınız?",
  "field.identity.name": "Ajan adı",
  "field.identity.brandName": "Marka",
  "field.identity.persona": "Kişilik",
  "field.languages.primary": "Dil",
  "field.direction": "Arama yönü",
  "field.mission.goal": "Aramanın amacı",
  "field.mission.successCondition": "Başarı ölçütü",
  "field.mission.audience": "Hedef kitle",
  "field.facts": "Toplanacak bilgiler",
  "field.style.tone": "Ton",
  "field.compliance.require[recording_notice].instruction": "Kayıt bildirimi",
  "field.compliance.require[ai_disclosure].instruction": "Yapay zekâ beyanı",
  "field.globalIntents[opt_out].description": "Listeden çıkma talebi",
  "agent.back": "← Ajanlar",
  "agent.tab.assets": "Asset'ler",
  "agent.kit.none": "Bu ajan için henüz satış kiti yok.",
  "agent.kit.build": "Satış kitini üret",
  "agent.kit.rebuild": "Kiti yeniden üret",
  "agent.kit.building": "Kit hazırlanıyor… (yaklaşık 1 dakika)",
  "agent.kit.failed": "Kit üretilemedi",
  "agent.kit.version": "Sürüm {v} · {lang}",
  "agent.kit.report": "{generated} cümle üretildi · {repaired} onarıldı · {dropped} çıkarıldı",
  "kit.angles": "Değer açıları",
  "kit.angles.hint": "Müşteriye farklı yönlerden girmek için hazır sunuşlar",
  "kit.pitch": "Sunuş",
  "kit.proof": "Kanıt",
  "kit.question": "Soru",
  "kit.objections": "İtiraz kartları",
  "kit.objection.back": "Geri dönüş sorusu",
  "kit.discovery": "Keşif soruları",
  "kit.closings": "Kapanış hamleleri",
  "kit.bridges": "Köprü cümleleri",
  "kit.fallbacks": "Yedek cümleler",
  "kit.fallback.silence": "Sessizlikte",
  "kit.fallback.notUnderstood": "Anlaşılmadığında",
  "kit.fallback.technical": "Teknik sorunda",
  "license.licensed": "Bilgiyle doğrulandı",
  "license.not_required": "İddia yok",
  "license.conversational": "Sohbet cümlesi",
  "edit": "Düzenle",
  "save": "Kaydet",
  "cancel": "Vazgeç",
  "saving": "Doğrulanıyor…",
  "error.KIT_LINE_UNLICENSED": "Bu cümle Business Brain'deki bilgilerle doğrulanamadı. Yeni bir bilgi eklemek istiyorsanız önce Business Brain'e ekleyin.",
  "reason.UNSUPPORTED_NUMBER": "İçindeki sayı Business Brain'de geçmiyor.",
  "reason.UNSUPPORTED_CLAIM": "İşletme hakkında Business Brain'de olmayan bir iddia içeriyor.",
  "reason.BRIDGE_HAS_CLAIM": "Köprü cümleleri bilgi içeremez.",
  "error.AGENT_NOT_FOUND": "Ajan bulunamadı.",
  "error.KIT_INSUFFICIENT_ANGLES": "Yeterli sayıda doğrulanmış değer açısı çıkarılamadı. Business Brain'e ürün/hizmet bilgisi ekleyip tekrar deneyin.",
  "error.JOB_INTERRUPTED": "İşlem yarıda kesildi, tekrar deneyin.",
  "agent.tab.preview": "Önizleme",
  "preview.hint": "Ajanla yazışarak deneyin. Siz müşteri gibi yazın; ajan telefonda konuşur gibi cevap verir. Telefon çalmaz.",
  "preview.start": "Önizlemeyi başlat",
  "preview.restart": "Yeniden başlat",
  "preview.ended": "Ajan görüşmeyi bitirdi.",
  "preview.turn": "Bu tur",
  "preview.angle": "Açı",
  "preview.move": "Hamle",
  "preview.mood": "Müşteri",
  "preview.facts": "Toplanan bilgi",
  "preview.angles": "Denenen açılar",
  "preview.critics": "Denetçiler",
  "preview.ms": "Süre",
  "preview.bridge": "Köprü",
  "preview.none": "—",
  "preview.needKit": "Önizleme için önce satış kitini üretin.",
  "error.AGENT_NOT_READY": "Önizleme için önce satış kitini üretin.",
  "error.PREVIEW_NOT_FOUND": "Önizleme süresi doldu, yeniden başlatın.",
  "agent.tab.tests": "Test & Karne",
  "score.hint": "Ajan, sabırsız, kaba, şüpheci, reddeden, kafası karışık ve rakipten memnun yapay müşterilerle telefonsuz konuşur; her konuşma puanlanır. Karne geçmeden ajan yayına alınmaz.",
  "score.run": "Karneyi çalıştır",
  "score.running": "Karne çalışıyor… (birkaç dakika)",
  "score.none": "Henüz karne yok.",
  "score.pass": "Kapıdan geçti",
  "score.fail": "Kapıdan kaldı",
  "score.failures": "Eşiği tutmayanlar",
  "metric.naturalness": "Doğallık",
  "metric.intent": "Niyeti anlama",
  "metric.respect": "Saygı",
  "metric.persuasion": "İkna",
  "metric.questionRate": "Soru oranı",
  "metric.factCoverage": "Toplanan bilgi",
  "metric.nextStepRate": "Sonraki adım",
  "metric.repeats": "Tekrar",
  "metric.silentTurns": "Sessiz tur",
  "metric.identityRepeats": "Kimlik tekrarı",
  "statements.title": "İşletme cevapları",
  "statements.hint": "Müşterilerin sık sorduğu sorulara işletmenizin kendi cevabı. Konu açıldığında ajan bu bilgiyle cevap verir; buraya yazdığınız bilgi doğrulanmış kabul edilir.",
  "statements.contactSource": "\"Numaramı nereden aldınız?\" sorusunun cevabı",
  "statements.contactSource.placeholder": "Örn. İletişim bilginiz kamuya açık işletme rehberinden alındı.",
  "statements.topic": "Konu (örn. ücret)",
  "statements.answer": "Cevap",
  "statements.add": "Cevap ekle",
  "statements.remove": "Kaldır",
  "statements.saved": "Kaydedildi",
  "error.CONTACT_SOURCE_STATEMENT_REQUIRED": "Arama yapan ajanlar için \"numara nereden alındı\" cevabı zorunludur.",
  "error.SPEC_INVALID": "Cevaplar geçersiz (aynı konu iki kez girilmiş olabilir).",
  "humor.title": "Bilinmeyen sorularda üslup",
  "humor.hint": "Ajan cevabını bilmediği bir soruda dürüstçe söyler, sonra konuşmayı ilerletir. Hafif mizah açıksa bunu küçük, sıcak bir dokunuşla yapar.",
  "humor.light": "Hafif mizah (önerilen)",
  "humor.off": "Mizah yok, sade",
  "kit.plain": "Sade anlatım",
  "kit.plain.hint": "Müşteri anlamadığında ajanın kullandığı, teknik kelimesiz kısa açıklamalar.",
  "agent.publish": "Yayınla",
  "agent.publish.running": "Yayınlanıyor…",
  "agent.publish.hint": "Güncel ayarlar ve satış malzemesi değişmez bir sürüm olarak kaydedilir; gerçek aramalar yalnızca yayınlanmış sürümle yapılır.",
  "agent.publish.version": "yayındaki sürüm",
  "agent.publish.done": "Yayınlandı (sürüm {{id}}). Gerçek aramalar artık bu sürümle yapılacak.",
  "error.KIT_MISSING_FOR_LANGUAGE": "Yayınlamak için her dilde satış malzemesi gerekli.",
  "error.AGENT_NOT_PUBLISHED": "Ajan henüz yayınlanmadı.",
  "calls.title": "Aramalar · dinle ve takip et",
  "calls.subtitle": "Ajanlarınızın yaptığı aramalar, kayıtlar ve sonuçlar.",
  "calls.tab.all": "Tüm görüşmeler",
  "calls.tab.callbacks": "Geri aramalar",
  "calls.tab.dnc": "Aranmayacaklar",
  "calls.col.date": "Tarih",
  "calls.col.number": "Numara",
  "calls.col.agent": "Ajan",
  "calls.col.duration": "Süre",
  "calls.col.result": "Sonuç",
  "calls.col.callbackWhen": "Ne zaman",
  "calls.col.note": "Not",
  "calls.empty": "Henüz görüşme yok. Bir ajanın sayfasından “Ara” ile ilk aramayı başlatabilirsiniz.",
  "calls.callbacks.empty": "Bekleyen geri arama yok.",
  "calls.callbacks.done": "Arandı",
  "calls.hasRecording": "Kayıt var",
  "calls.result.machine": "Sesli mesaj",
  "calls.result.optedOut": "Listeden çıkmak istedi",
  "calls.result.callback": "Geri arama: {when}",
  "calls.result.live": "Sürüyor",
  "calls.result.notAnswered": "Cevaplanmadı",
  "calls.result.error": "Teknik hata",
  "calls.result.talked": "Görüşüldü",
  "calls.back": "Görüşmeler",
  "calls.recording": "Kayıt",
  "calls.noRecording": "Bu görüşmenin kaydı yok.",
  "calls.recordingTruncated": "Kayıt süre sınırı nedeniyle kısaltıldı.",
  "calls.transcript": "Konuşma",
  "calls.noTurns": "Konuşma dökümü yok.",
  "calls.event.silent": "Müşteri sessiz kaldı",
  "calls.callback": "Geri arama",
  "calls.callback.open": "Henüz aranmadı",
  "calls.callback.doneAt": "Arandı: {at}",
  "calls.facts": "Toplanan bilgiler",
  "calls.noFacts": "Bilgi toplanmadı.",
  "dnc.hint": "Bu numaralar hiçbir ajan tarafından aranmaz. Müşteri “beni aramayın” dediğinde numara buraya kendiliğinden eklenir.",
  "dnc.placeholder": "+90 5xx xxx xx xx",
  "dnc.add": "Listeye ekle",
  "dnc.remove": "Listeden çıkar",
  "dnc.empty": "Liste boş.",
  "dnc.col.reason": "Neden",
  "dnc.reason.opt_out": "Müşteri istedi",
  "dnc.reason.manual": "Elle eklendi",
  "call.start": "Ara",
  "call.placeholder": "Numara, ad ya da şirket yazın",
  "call.next": "Devam",
  "call.confirm": "{phone} numarası şimdi aranacak. Görüşme dakika ücreti yazar. Onaylıyor musunuz?",
  "call.yes": "Evet, ara",
  "call.dialing": "Aranıyor…",
  "call.started": "Arama başladı.",
  "call.openCall": "Görüşmeyi aç",
  "common.yes": "Evet",
  "common.no": "Hayır",
  "common.cancel": "Vazgeç",
  "common.back": "Geri",
  "error.CALL_NOT_FOUND": "Görüşme bulunamadı.",
  "error.RECORDING_NOT_FOUND": "Kayıt bulunamadı.",
  "error.CALLBACK_NOT_FOUND": "Bu görüşmede açık geri arama yok.",
  "error.PHONE_NOT_E164": "Numarayı ülke koduyla yazın (ör. +90 532 …).",
  "error.DO_NOT_CALL": "Bu numara aranmayacaklar listesinde.",
  "error.OUTBOUND_DISABLED": "Giden arama bu kurulumda açık değil.",
  "error.HISTORY_NOT_CONFIGURED": "Görüşme geçmişi bu kurulumda açık değil.",
  "error.DO_NOT_CALL_NOT_CONFIGURED": "Aranmayacaklar listesi bu kurulumda açık değil.",
  "calls.col.callbackState": "Durum",
  "callback.state.scheduled": "Elif arayacak: {at}",
  "callback.state.dialed": "Elif aradı",
  "callback.state.expired": "Zamanı kaçtı, aranmadı",
  "callback.state.notCalled": "Aranamadı: {reason}",
  "callback.state.manual": "Ekip arayacak",
  "callback.openCall": "Geri arama görüşmesini aç",
  "callback.fromCall": "← Bu, önceki bir görüşmede sözü verilen geri arama",
  "error.BILLING_PRINCIPAL_MISSING": "Faturalanacak hesap bulunamadı.",
  "error.VOICE_MINUTES_EXCEEDED": "Arama dakikası kalmadı.",
  "error.ORIGINATE_FAILED": "Hat açılamadı.",
  "ambience.title": "Arka plan sesi",
  "ambience.hint": "Görüşmenin arkasında hafif bir ortam sesi; ajan konuşurken kısılır.",
  "ambience.bed.none": "Yok",
  "ambience.bed.office": "Ofis ortamı",
  "ambience.level": "Seviye",
  "ambience.save": "Kaydet",
  "ambience.saved": "Kaydedildi — yayınlayınca aramalara yansır.",
  "error.DONE_BY_TEAM": "Ekip aradı (otomatik arama iptal)",
  "agent.tab.general": "Genel",
  "agent.tab.voice": "Ses",
  "agent.tab.knowledge": "Bilgi",
  "agent.tab.kit": "Satış kiti",
  "agent.tab.compliance": "Uyum",
  "agent.tab.test": "Test",
  "draft.differs": "Yayındaki sürümden farklı değişiklikler var (yayında: sürüm {live}, taslak: sürüm {draft}). Aramalara yansıması için yayınlayın.",
  "draft.notPublished": "Bu ajan henüz yayınlanmadı; gerçek aramalar yayınlanan sürümle yapılır.",
  "settings.identity": "Kimlik",
  "settings.mission": "Görev",
  "settings.maxSentences": "Bir cevapta en fazla cümle",
  "settings.maxSentences.hint": "Telefonda 2 önerilir.",
  "settings.facts.hint": "Ajanın görüşmede öğrenmeye çalışacağı bilgiler. Görüşme bitince “Görüşmeler” ekranında görünür.",
  "settings.facts.label": "Bilgi",
  "settings.facts.type": "Tür",
  "settings.facts.required": "Zorunlu",
  "settings.facts.add": "Bilgi ekle",
  "settings.facts.enumPlaceholder": "Seçenekler, virgülle (ör. kayit, geri arama)",
  "settings.factType.text": "Metin",
  "settings.factType.boolean": "Evet/Hayır",
  "settings.factType.number": "Sayı",
  "settings.factType.enum": "Seçenekli",
  "settings.factType.datetime": "Tarih-saat",
  "settings.factType.phone": "Telefon",
  "settings.factType.email": "E-posta",
  "settings.remove": "Sil",
  "settings.save": "Kaydet",
  "settings.saving": "Kaydediliyor…",
  "settings.saved": "Kaydedildi — yayınlayınca aramalara yansır.",
  "settings.compliance": "Zorunlu söylenecekler",
  "settings.compliance.hint": "Ajan bunları görüşmenin başında mutlaka söyler.",
  "settings.boundaries": "Sınırlar",
  "settings.blockedTopics": "Hiç konuşulmayacak konular",
  "settings.mustNotPromise": "Asla söz verilmeyecekler",
  "settings.onePerLine": "Her satıra bir tane.",
  "assist.title": "Yapay zekâya söyle",
  "assist.hint": "Ne değişsin, kendi cümlenizle yazın; önerilen değişikliği görüp onaylayınca kaydedilir.",
  "assist.placeholder": "Ör. Daha samimi konuşsun, cevapları kısa tutsun",
  "assist.ask": "Öner",
  "assist.thinking": "Düşünüyor…",
  "assist.proposal": "Önerilen değişiklik",
  "assist.noChange": "Değişiklik önerilmedi.",
  "assist.apply": "Uygula",
  "field.style.maxSentencesPerTurn": "Bir cevapta en fazla cümle",
  "field.style.maxQuestionsPerTurn": "Bir cevapta en fazla soru",
  "field.style.humor": "Mizah",
  "field.boundaries.blockedTopics": "Konuşulmayacak konular",
  "field.boundaries.mustNotPromise": "Söz verilmeyecekler",
  "field.timezone": "Saat dilimi",
  "field.compliance.require": "Zorunlu söylenecekler",
  "field.globalIntents": "Niyetler",
  "field.statements": "İşletme cevapları",
  "field.ambience": "Arka plan sesi",
  "error.SPEC_FIELD_LOCKED": "Bu alan buradan değiştirilemez.",
  "error.SPEC_ASSIST_BAD_OUTPUT": "Yapay zekâ geçerli bir öneri üretemedi; isteği biraz farklı yazıp tekrar deneyin.",
  "error.VALIDATION_FAILED": "Bazı alanlar eksik ya da geçersiz.",
  "voice.title": "Ajanın sesi",
  "voice.hint": "Her ses, ajanınızın kendi cümlesini okur. Dinleyip seçin; kaydedip yayınlayınca aramalarda bu ses kullanılır.",
  "voice.filter.all": "Tümü",
  "voice.filter.female": "Kadın",
  "voice.filter.male": "Erkek",
  "voice.gender.female": "Kadın",
  "voice.gender.male": "Erkek",
  "voice.speed": "Konuşma hızı",
  "voice.listen": "Dinle",
  "voice.stop": "Durdur",
  "voice.loading": "Hazırlanıyor…",
  "voice.default": "Henüz ses seçilmedi; platformun varsayılan sesi kullanılıyor.",
  "error.VOICES_NOT_CONFIGURED": "Ses kataloğu bu kurulumda açık değil.",
  "error.VOICES_UNAVAILABLE": "Ses listesi şu an alınamadı.",
  "error.VOICE_SAMPLE_FAILED": "Örnek ses üretilemedi.",
  "field.voice": "Ses",
  "agent.back.short": "Ajanlar",
  "agent.status.live": "Yayında",
  "agent.status.changed": "Yayınlanmamış değişiklik var",
  "agent.status.draft": "Yayınlanmadı",
  "agent.liveVersion": "yayında sürüm {v}",
  "agent.draftVersion": "taslak sürüm {v}",
  "agent.publish.upToDate": "Güncel",
  "settings.identity.hint": "Ajanın kendini tanıtırken kullandığı ad ve temsil ettiği marka.",
  "settings.personality": "Kişilik ve üslup",
  "settings.personality.hint": "Nasıl bir insan gibi konuşacağı. Kısa ve net cevaplar telefonda daha doğal duyulur.",
  "settings.mission.hint": "Aramanın neden yapıldığı, neyin başarı sayıldığı ve kiminle konuşulduğu. Ajan her cevabını buna göre seçer.",
  "settings.boundaries.hint": "Ajanın hiç açmayacağı konular ve asla vermeyeceği sözler.",
  "settings.unsaved": "Kaydedilmemiş değişiklikler var",
  "settings.discard": "Vazgeç",
  "common.sure": "Emin misiniz?",
  "voice.search": "Ses ara",
  "voice.own": "Sizin sesiniz",
  "voice.chosen": "Seçili",
  "voice.speed.hint": "1,00 normal hızdır. Telefonda biraz yavaş (0,95) daha anlaşılır olabilir.",
  "voice.age.young": "Genç",
  "voice.age.middle_aged": "Orta yaş",
  "voice.age.middle aged": "Orta yaş",
  "voice.age.old": "Olgun",
  "voice.accent.american": "Amerikan aksanı",
  "voice.accent.british": "İngiliz aksanı",
  "voice.accent.australian": "Avustralya aksanı",
  "voice.accent.irish": "İrlanda aksanı",
  "voice.accent.turkish": "Türkçe",
  "voice.accent.standard": "Standart",
  "ambience.bed.none.hint": "Arka planda ses yok.",
  "ambience.bed.office.hint": "Hafif bir ofis ortamı; ajan konuşurken kısılır.",
  "knowledge.source.label": "Cevap",
  "knowledge.source.hint": "Müşteri “numaramı nereden aldınız?” diye sorarsa ajanın vereceği cevap.",
  "knowledge.source.hint.required": "Müşteri “numaramı nereden aldınız?” diye sorarsa ajanın vereceği cevap. Arama yapan ajanlar için zorunludur.",
  "knowledge.empty": "Henüz işletme cevabı yok. Müşterilerin sık sorduğu bir soruyla başlayın.",
  "knowledge.done": "Tamam",
  "humor.light.hint": "Bilmediği bir soruda dürüstçe söyler, küçük sıcak bir dokunuşla konuyu toparlar.",
  "humor.off.hint": "Bilmediği bir soruda sade ve ciddi bir dille söyler.",
  "calls.search": "Ad, numara ya da ajan ara",
  "calls.prior": "Önceki görüşmeler: {n}",
  "calls.counterpart.title": "Bu numarayla görüşmeler",
  "calls.counterpart.counts": "Toplam: {total} · Bundan önce: {before}",
  "calls.counterpart.none": "Bu numarayla başka görüşme yok.",
  "calls.counterpart.all": "Tümünü göster",
  "calls.counterpart.inContacts": "Rehberde",
  "calls.counterpart.notInContacts": "Rehberde yok",
  "calls.counterpart.name": "Ad (isteğe bağlı)",
  "calls.counterpart.add": "Rehbere ekle",
  "calls.counterpart.addHint": "Yalnız numara ve yazdığınız ad kaydedilir; kişi otomatik aranmaz. Veri silme talebinde bu kayıt da silinir.",
  "calls.counterpart.added": "Rehbere eklendi.",
  "calls.counterpart.exists": "Bu numara zaten rehberde.",
  "calls.filter.sameNumber": "Yalnız bu numarayla görüşmeler",
  "calls.filter.clear": "Filtreyi kaldır",
  "calls.party.none": "Numara yok",
  "calls.kind.all": "Tümü",
  "calls.kind.callback": "Geri arama",
  "calls.kind.talked": "Görüşüldü",
  "calls.kind.machine": "Sesli mesaj",
  "calls.kind.optedOut": "Listeden çıktı",
  "voice.gender.neutral": "Nötr",
  "app.subtitle": "Müşteri operasyonları",
  "app.workspace": "Çalışma alanı",
  "nav.group.daily": "Günlük iş",
  "nav.group.build": "Oluşturma",
  "nav.group.setup": "Kurulum",
  "nav.overview": "Genel Bakış",
  "nav.callbacks": "Geri aramalar",
  "nav.campaigns": "Kampanyalar",
  "nav.leads": "Leadler",
  "nav.doNotCall": "Aranmayacaklar",
  "nav.agent": "AI Ajanları",
  "nav.calls": "Görüşmeler",
  "nav.call": "Görüşmeler",
  "theme.label": "Tema",
  "theme.dark": "Koyu",
  "theme.light": "Açık",
  "overview.badge": "BUGÜNKÜ OPERASYON",
  "overview.strip": "Bugün ne oldu, sırada ne var — hepsi burada.",
  "overview.refresh": "Yenile",
  "overview.queue.kicker": "Canlı kuyruk",
  "overview.queue.title": "Dikkat gerekenler",
  "overview.kpi.today": "Bugünkü aramalar",
  "overview.kpi.talked": "Görüşülen",
  "overview.kpi.callbacks": "Bekleyen geri arama",
  "overview.kpi.machine": "Sesli mesaja düşen",
  "overview.kpi.avg": "Ortalama görüşme",
  "overview.kpi.agents": "Yayındaki ajanlar",
  "overview.att.noAgent": "Yayında ajan yok",
  "overview.att.noAgent.body": "Arama yapabilmek için bir ajanı yayınlayın.",
  "overview.att.noAgent.cta": "Ajanlara git",
  "overview.att.manual": "{n} geri arama ekibinizi bekliyor",
  "overview.att.manual.body": "Bu müşterilere söz verildi; aradıktan sonra “Arandı” olarak işaretleyin.",
  "overview.att.callbacks.cta": "Geri aramalara git",
  "overview.att.auto": "{n} otomatik geri arama planlandı",
  "overview.att.auto.body": "Sıradaki: {at} · {agent} arayacak.",
  "overview.att.changed": "{name}: yayınlanmamış değişiklik var",
  "overview.att.changed.body": "Yaptığınız ayarlar aramalara ancak yayınlayınca yansır.",
  "overview.att.changed.cta": "Ajana git",
  "overview.att.errors": "Bugün {n} arama teknik hatayla bitti",
  "overview.att.errors.body": "Görüşme kayıtlarından nedenine bakın.",
  "overview.att.errors.cta": "Görüşmeleri incele",
  "overview.att.none": "Şu an bekleyen bir iş yok",
  "overview.att.none.body": "Yeni aramalar ve geri aramalar geldikçe burada görünür.",
  "overview.command.kicker": "Komuta merkezi",
  "overview.command.title": "Sırada ne yapmalıyım?",
  "overview.command.body": "Arama başlatın, görüşmeleri dinleyin, geri aramaları takip edin — ana sayfa iş kuyruğudur.",
  "overview.command.call": "{name} ile arama başlat",
  "overview.command.create": "İlk ajanı oluştur",
  "overview.command.review": "Görüşmeleri incele",
  "overview.command.callbacks": "Geri aramalar",
  "overview.step.create": "Oluştur",
  "overview.step.create.body": "Stüdyo'da yapay zekâyla ajanınızı kurun.",
  "overview.step.publish": "Yayınla",
  "overview.step.publish.body": "Ses ve ayarları seçip yayınlayın.",
  "overview.step.call": "Ara",
  "overview.step.call.body": "Ajan sayfasından numarayı arayın.",
  "overview.step.follow": "Takip et",
  "overview.step.follow.body": "Kaydı dinleyin, geri aramaları kapatın.",
  "overview.recent": "Son görüşmeler",
  "overview.recent.all": "Tümünü gör",
  "calls.card": "Arama kartı",
  "calls.tile.duration": "Süre",
  "calls.tile.recording": "Kayıt",
  "calls.tile.turns": "Müşteri konuştu",
  "calls.tile.ended": "Kapatan",
  "calls.tile.ready": "Hazır",
  "calls.endedBy.agent": "Ajan",
  "calls.endedBy.caller": "Karşı taraf",
  "calls.endedBy.error": "Hata",
  "calls.cardTab.summary": "Özet",
  "calls.cardTab.transcript": "Konuşma",
  "calls.cardTab.recording": "Kayıt",
  "calls.recording.hint": "Sol kulakta karşı taraf, sağ kulakta ajan.",
  "calls.list.kicker": "Liste",
  "calls.list.title": "Arama geçmişi",
  "calls.kind.today": "Bugün",
  "calls.kind.recorded": "Kayıtlı",
  "calls.none": "Bu süzgeçte arama yok.",
  "calls.pick": "Soldan bir arama seçin.",
  "agents.subtitle": "Oluştur, ayarla, yayınla, sonra test et · {n} ajan",
  "agents.path.create": "Oluştur",
  "agents.path.tune": "Ayarla",
  "agents.path.publish": "Yayınla",
  "agents.path.test": "Test araması",
  "agents.stat.total": "Toplam ajan",
  "agents.stat.outbound": "Giden",
  "agents.stat.inbound": "Gelen",
  "agents.stat.live": "Yayında",
  "agents.filter.all": "Tümü",
  "agents.filter.outbound": "Giden",
  "agents.filter.inbound": "Gelen",
  "agents.filter.live": "Yayında",
  "agents.filter.draft": "Taslak / değişiklik",
  "agents.search": "Ajan ara",
  "agents.open": "Aç",
  "agent.tab.actions": "Aksiyonlar",
  "actions.callback": "Geri arama",
  "actions.callback.hint": "Müşteri “sonra arayın” derse ajanın saat alıp söz verip veremeyeceği. Saat dilimi seçiliyse ajan o saatte kendisi arar.",
  "actions.callback.on": "Geri arama sözü verebilir",
  "actions.callback.on.hint": "Saati alır, kaydeder; zamanı gelince ajan arar.",
  "actions.callback.off": "Geri arama sözü vermez",
  "actions.callback.off.hint": "Başka bir sonraki adım önerir.",
  "actions.callback.when": "Ne zaman geri arama önerilsin",
  "actions.callback.when.hint": "Ajan bu durumlarda geri arama önerir; kendi cümlelerinizle yazın.",
  "actions.callback.defaultDescription": "Müşteri şu an konuşamıyor, yetkiliyle görüşmek istiyor ya da daha sonra aranmayı kabul ediyor",
  "actions.timezone": "Saat dilimi",
  "actions.timezone.hint": "Müşterinin söylediği “yarın 10:30” gibi saatler bu dilime göre anlaşılır.",
  "actions.timezone.none": "Seçilmedi",
  "actions.timezone.browser": "Bu cihazınkini kullan ({zone})",
  "actions.timezone.needed": "Saat dilimi seçilmezse geri aramalar otomatik yapılmaz, yalnız ekibin listesine düşer.",
  "actions.hours": "Arama saatleri",
  "actions.hours.hint": "Bu ajanın kendisinin arayacağı (geri arama, kampanya) ve geri arama sözü verebileceği saatler. Numaralara gelen aramaların saatleri Telefon numaraları sayfasında ayarlanır.",
  "actions.hours.any": "Her zaman",
  "actions.hours.any.hint": "Saat sınırı yok.",
  "actions.hours.limited": "Belirli gün ve saatler",
  "actions.hours.limited.hint": "Önce saat dilimini seçin.",
  "actions.hours.start": "Başlangıç",
  "actions.hours.end": "Bitiş",
  "actions.hours.invalid": "En az bir gün seçin; bitiş saati başlangıçtan sonra olmalı.",
  "day.1": "Pzt",
  "day.2": "Sal",
  "day.3": "Çar",
  "day.4": "Per",
  "day.5": "Cum",
  "day.6": "Cmt",
  "day.7": "Paz",
  "field.businessHours": "Mesai saatleri",
  "error.OUTSIDE_HOURS": "Mesai dışı",
  "actions.hours.limited.ready": "Seçili günlerde, belirlediğiniz saatler arasında.",
  "agent.tab.conversation": "Konuşma",
  "pace.title": "Konuşma temposu",
  "pace.hint": "Ajanın müşteriyi ne kadar beklediği: sustuğunu anlamadan önce, sessizlikte tekrar konuşmadan önce ve açılışta “alo” için.",
  "pace.relaxed": "Sabırlı",
  "pace.relaxed.hint": "Daha uzun bekler; düşünerek ya da yavaş konuşan kitleler için.",
  "pace.normal": "Normal",
  "pace.normal.hint": "Çoğu görüşme için önerilen.",
  "pace.quick": "Hızlı",
  "pace.quick.hint": "Kısa cevaplı, hızlı tempolu görüşmeler için.",
  "field.pace": "Konuşma temposu",
  "studio.templates.kicker": "Hızlı başlangıç",
  "studio.templates.title": "Sohbet ederek ajanınızı kurun",
  "studio.templates.hint": "Yapay zekâ adım adım sorar, siz cevaplarsınız. Hazır bir ajanla hızlı başlamak isterseniz \"Hazır ajanlar\"ı seçin.",
  "studio.templates.blank": "Boş başla",
  "studio.templates.blank.hint": "Yapay zekâ baştan sorarak birlikte kurar.",
  "error.TEMPLATE_NOT_FOUND": "Şablon bulunamadı.",
  "nav.contacts": "Rehber",
  "nav.campaign": "Kampanyalar",
  "contacts.title": "Rehber",
  "contacts.subtitle": "Kampanyaların arayacağı kişiler · {n} kişi",
  "contacts.import": "Toplu ekle (Excel / CSV)",
  "contacts.file": "CSV dosyası seç",
  "contacts.import.hint": "Excel ya da Google Sheets'ten satırları kopyalayıp yapıştırın ya da CSV dosyası seçin. Telefon sütunu kendiliğinden bulunur; ilk satır başlıksa diğer sütunlar ek bilgi olarak saklanır. Numaraları ülke koduyla yazın (+90…).",
  "contacts.import.placeholder": "Ad\tTelefon\tŞehir\nAyşe Eczanesi\t+90 532 000 00 01\tİzmir",
  "contacts.preview": "{n} satır bulundu · sütunlar: {columns}",
  "contacts.add": "{n} kişiyi ekle",
  "contacts.imported": "{inserted} yeni kişi eklendi, {updated} kişi güncellendi, {invalid} satırın numarası geçersizdi.",
  "contacts.search": "Ad ya da numara ara",
  "contacts.empty": "Rehber boş. Yukarıdan kişi ekleyin.",
  "contacts.col.name": "Ad",
  "contacts.col.fields": "Ek bilgiler",
  "campaigns.title": "Kampanyalar",
  "campaigns.subtitle": "Bir ajanın rehberdeki kişileri sırayla araması; ulaşılamayanlar tekrar denenir.",
  "campaigns.new": "Yeni kampanya",
  "campaigns.empty": "Henüz kampanya yok.",
  "campaigns.status.draft": "Taslak",
  "campaigns.status.running": "Arıyor",
  "campaigns.status.paused": "Duraklatıldı",
  "campaigns.status.done": "Bitti",
  "campaigns.status.cancelled": "İptal edildi",
  "campaigns.targets": "{n} kişi",
  "campaigns.stat.total": "Toplam",
  "campaigns.stat.pending": "Sırada",
  "campaigns.stat.dialing": "Aranıyor",
  "campaigns.stat.done": "Görüşüldü",
  "campaigns.stat.failed": "Ulaşılamadı",
  "campaigns.stat.skipped": "Atlandı",
  "campaigns.stat.left": "kalan",
  "campaigns.step.1": "Ad ve ajan",
  "campaigns.step.2": "Kişiler",
  "campaigns.step.3": "Ayarlar",
  "campaigns.step.4": "Özet",
  "campaigns.name": "Kampanya adı",
  "campaigns.name.placeholder": "Ör. Ekim — İzmir eczaneleri",
  "campaigns.agent": "Arayacak ajan",
  "campaigns.agent.hint": "Yalnız yayında olan ve arama yapan ajanlar listelenir.",
  "campaigns.agent.none": "Arama yapabilecek yayında bir ajan yok; önce bir ajan yayınlayın.",
  "campaigns.contacts.none": "Rehberde kişi yok.",
  "campaigns.contacts.go": "Rehbere git",
  "campaigns.picked": "{n} / {total} seçili",
  "campaigns.all": "Tümü",
  "campaigns.none": "Hiçbiri",
  "campaigns.concurrency": "Aynı anda arama",
  "campaigns.concurrency.hint": "Kaç kişinin aynı anda aranacağı. Hattınızın aynı anda kaç arama taşıdığına göre seçin; emin değilseniz 1.",
  "campaigns.attempts": "Deneme sayısı",
  "campaigns.attempts.hint": "Açılmayan, sesli mesaja düşen ya da hemen kapanan aramalar bu sayıya kadar tekrar denenir.",
  "campaigns.retry": "Tekrar aralığı",
  "campaigns.minutes": "{n} dakika",
  "campaigns.hours": "{n} saat",
  "campaigns.day": "1 gün",
  "campaigns.hours.note": "Aramalar ajanın mesai saatlerinde yapılır (Ajan → Aksiyonlar). Aranmayacaklar listesindeki numaralar hiç aranmaz.",
  "campaigns.confirm": "{n} kişi aranacak. Her görüşme dakika ücreti yazar. Başlatılsın mı?",
  "campaigns.confirm.yes": "Evet, başlat",
  "campaigns.saveDraft": "Taslak olarak kaydet",
  "campaigns.createStart": "Oluştur ve başlat",
  "campaigns.start": "Başlat",
  "campaigns.resume": "Devam et",
  "campaigns.pause": "Duraklat",
  "campaigns.cancel": "İptal et",
  "campaigns.settings": "aynı anda {c} · {a} deneme · {r} dk arayla",
  "campaigns.col.status": "Durum",
  "campaigns.col.attempts": "Deneme",
  "campaigns.target.pending": "Sırada",
  "campaigns.target.dialing": "Aranıyor",
  "campaigns.target.done": "Görüşüldü",
  "campaigns.target.failed": "Ulaşılamadı",
  "campaigns.target.skipped": "Atlandı",
  "campaigns.result.talked": "Görüşüldü",
  "campaigns.result.callback": "Geri arama",
  "campaigns.result.opted_out": "Listeden çıkmak istedi",
  "campaigns.result.no_answer": "Cevap yok",
  "campaigns.result.voicemail": "Sesli mesaj",
  "campaigns.result.error": "Teknik hata",
  "campaigns.result.skipped": "Atlandı",
  "campaigns.result.retry": "Sonra yeniden denenecek",
  "error.CAMPAIGN_FINISHED": "Bu kampanya bitti ya da iptal edildi.",
  "error.CAMPAIGN_NOT_FOUND": "Kampanya bulunamadı.",
  "error.CONTACT_NOT_FOUND": "Kişi bulunamadı.",
  "leads.title": "Leadler",
  "leads.subtitle": "Satış hattı · {n} kişi · {hot} sıcak aday",
  "leads.empty": "Henüz kişi yok. Rehbere kişi ekleyip kampanya başlatınca görüşmeler buraya düşer.",
  "leads.openCall": "Son görüşme",
  "leads.notCalled": "Henüz aranmadı",
  "leads.moveTo": "Aşamaya taşı",
  "leads.score.hot": "Sıcak",
  "leads.score.warm": "Ilık",
  "leads.score.cold": "Soğuk",
  "leads.stage.new": "Yeni",
  "leads.stage.contacted": "Görüşüldü",
  "leads.stage.interested": "İlgileniyor",
  "leads.stage.callback": "Geri aranacak",
  "leads.stage.won": "Kazanıldı",
  "leads.stage.lost": "Kaybedildi",
  "calls.analysis": "Görüşme özeti",
  "calls.nextAction": "Sonraki adım:",
  "calls.sentiment.positive": "Olumlu",
  "calls.sentiment.neutral": "Nötr",
  "calls.sentiment.negative": "Olumsuz",
  "contacts.col.stage": "Aşama",
  "contacts.col.kind": "Tür",
  "contacts.kind.label": "Numara türü",
  "contacts.kind.hint": "“Bilinmiyor” şahıs gibi işlenir (temkinli taraf).",
  "contacts.kind.business": "İşletme",
  "contacts.kind.person": "Şahıs",
  "contacts.kind.unknown": "Bilinmiyor",
  "contacts.kind.all": "Tümü",
  "contacts.kind.header.aliases": "numara türü|numara turu|tür|tip",
  "contacts.kind.business.aliases": "işletme|şirket|kurumsal|tacir|ticari",
  "contacts.kind.person.aliases": "şahıs|bireysel|kişi|tüketici",
  "contacts.kind.unknown.aliases": "bilinmiyor|belirsiz",
  "lines.title": "Telefon hatları",
  "lines.subtitle": "Kendi SIP hattınızı bağlayın, numaranızı hangi ajanın cevaplayacağını ve ajanların hangi numaradan arayacağını seçin.",
  "lines.add": "Hat ekle",
  "lines.edit": "Düzenle",
  "lines.save": "Kaydet ve bağlan",
  "lines.saved": "Kaydedildi.",
  "lines.applied": "Hatlar santrale uygulandı.",
  "lines.notApplied": "Kaydedildi ama santrale şu an uygulanamadı.",
  "lines.retry": "Tekrar dene",
  "lines.empty": "Henüz hat yok. SIP sağlayıcınızdan aldığınız kullanıcı adı ve şifreyle ilk hattınızı ekleyin.",
  "lines.provider.verimor": "Verimor",
  "lines.provider.zadarma": "Zadarma",
  "lines.provider.sip": "Diğer SIP",
  "lines.provider.verimor.hint": "Verimor panelinde Santral → SIP hesapları bölümündeki kullanıcı adı (genelde numaranız) ve şifre.",
  "lines.provider.zadarma.hint": "Zadarma kişisel hesabında Ayarlar → SIP bağlantısı bölümündeki SIP kullanıcı adı (ör. 123456-100) ve şifre.",
  "lines.provider.sip.hint": "Sağlayıcınızın verdiği SIP sunucusu, kullanıcı adı ve şifre. Hat santrale kayıt (register) olarak bağlanır.",
  "lines.label": "Hat adı",
  "lines.label.hint": "Kendiniz için, ör. Satış hattı.",
  "lines.username": "SIP kullanıcı adı",
  "lines.username.hint": "Sağlayıcınızın verdiği kullanıcı adı.",
  "lines.password": "SIP şifresi",
  "lines.password.keep": "Boş bırakırsanız mevcut şifre korunur.",
  "lines.host": "SIP sunucusu",
  "lines.port": "Port",
  "lines.authUsername": "Kimlik doğrulama kullanıcısı",
  "lines.authUsername.hint": "Yalnızca sağlayıcınız ayrı bir kullanıcı verdiyse.",
  "lines.advanced": "Gelişmiş ayarlar",
  "lines.secretNote": "Şifre şifrelenmiş olarak saklanır; bir daha gösterilmez.",
  "lines.system": "Sistem hattı",
  "lines.state.registered": "Bağlı",
  "lines.state.rejected": "Şifre/kullanıcı reddedildi",
  "lines.state.unreachable": "Sunucuya ulaşılamıyor",
  "lines.state.pending": "Bağlanıyor…",
  "lines.state.unknown": "Durum alınamadı",
  "lines.unverified": "Hat ilk kez başarıyla bağlandığında gelen aramalar bu hattın numaralarına düşmeye başlar.",
  "lines.number": "Numara",
  "lines.numberLabel": "Açıklama",
  "lines.numberLabel.placeholder": "ör. Ana hat",
  "lines.inboundAgent": "Gelen aramayı cevaplayan",
  "lines.inbound.none": "V2 cevaplamaz",
  "lines.notPublished": "yayında değil",
  "lines.addNumber": "Numara ekle",
  "lines.numberAdded": "Numara eklendi.",
  "lines.outbound.title": "Giden aramalar hangi numaradan?",
  "lines.outbound.hint": "Her ajan kendi numarasından arayabilir. Seçmezseniz platformun varsayılan hattı kullanılır.",
  "lines.agent": "Ajan",
  "lines.outbound.number": "Arayan numara",
  "lines.outbound.default": "Varsayılan hat",
  "error.SIP_FIELD_INVALID": "Bir alan geçersiz. Sunucu küçük harf alan adı ya da IP olmalı; kullanıcı adında boşluk ve @ olmamalı; şifrede ters eğik çizgi (\\) kullanılamaz.",
  "error.PROVIDER_UNKNOWN": "Bu sağlayıcı tanınmıyor.",
  "error.NUMBER_TAKEN": "Bu numara platformda başka bir işletmeye kayıtlı.",
  "error.LINE_NOT_FOUND": "Hat bulunamadı.",
  "error.NUMBER_NOT_FOUND": "Numara bulunamadı.",
  "error.TELEPHONY_NOT_CONFIGURED": "Telefon hatları bu kurulumda henüz açık değil.",
  "numbers.title": "Telefon numaraları",
  "numbers.subtitle": "İşletmenizin SIP numaralarını ekleyin; her numaraya gelen aramayı hangi ajanın cevaplayacağını ve hangi ajanların o numaradan arayacağını seçin.",
  "numbers.add": "Numara ekle",
  "numbers.step.1": "SIP hesabı",
  "numbers.step.2": "Numara",
  "numbers.step.3": "Ajanlar",
  "numbers.newAccount": "Yeni SIP hesabı bağla",
  "numbers.newAccount.hint": "Sağlayıcınızdan aldığınız kullanıcı adı ve şifreyle.",
  "numbers.accountCreated": "SIP hesabı bağlandı. Numarayı ekleyerek devam edin.",
  "numbers.e164.hint": "Ülke koduyla yazın (+90…). Bu numara platformda yalnız sizin işletmenize ait olur.",
  "numbers.inbound": "Gelen aramayı cevaplayan",
  "numbers.inbound.hint": "Bu numarayı arayanlarla konuşacak ajan. Yalnız yayındaki ajanlar seçilebilir.",
  "numbers.outbound": "Bu numaradan arayan ajanlar",
  "numbers.outbound.hint": "Seçilen ajanlar giden aramalarda (tek arama, kampanya, geri arama) müşteriye bu numarayla görünür. Bir ajan tek numaradan arar.",
  "numbers.nowUses": "şu an {number}",
  "numbers.noAgents": "Henüz ajan yok.",
  "numbers.back": "Geri",
  "numbers.next": "Devam",
  "numbers.finish": "Numarayı ekle",
  "numbers.added": "Numara eklendi ve ajanlara bağlandı.",
  "numbers.empty": "Henüz numara yok. “Numara ekle” ile SIP hesabınızı bağlayıp ilk numaranızı ekleyin.",
  "numbers.account": "SIP hesabı",
  "numbers.addCaller": "+ Ajan ekle",
  "numbers.defaultNote": "Hiçbir numaraya bağlanmamış ajanlar platformun varsayılan hattından arar.",
  "numbers.plan": "Çalışma saatleri",
  "numbers.plan.always": "Her zaman açık",
  "numbers.plan.add": "Saat ekle",
  "numbers.plan.needAgent": "Önce gelen aramayı cevaplayan ajanı seçin.",
  "numbers.plan.now.open": "Şu an açık",
  "numbers.plan.now.closed": "Şu an kapalı",
  "numbers.plan.now.holiday": "Bugün kapalı gün",
  "numbers.plan.after.same": "Mesai dışı: aynı ajan",
  "numbers.plan.after.agent": "Mesai dışı: {agent}",
  "numbers.plan.after.refuse": "Mesai dışı: cevaplanmaz",
  "plan.title": "Çalışma saatleri · {number}",
  "plan.edit": "Düzenle",
  "plan.scopeNote": "Bu saatler yalnız bu numaraya gelen aramalar içindir. Ajanların arayacağı saatler (geri arama, kampanya) her ajanın Eylemler sekmesinde ayarlanır.",
  "plan.mode.always": "Her zaman",
  "plan.mode.always.hint": "Saat sınırı yok; bugünkü gibi her arama aynı ajana gider.",
  "plan.mode.limited": "Belirli gün ve saatlerde",
  "plan.timezone.agent": "Ajanınkini kullan ({zone})",
  "plan.copyAgent": "Ajanın arama saatlerini kopyala",
  "plan.day.closed": "Kapalı",
  "plan.day.allDay": "24 saat",
  "plan.window.add": "+ İkinci aralık",
  "plan.window.remove": "Aralığı kaldır",
  "plan.applyAll": "Bu saatleri tüm açık günlere uygula",
  "plan.overnight.hint": "Gece yarısını aşan saatler için iki gün ayrı girin (ör. 22:00–24:00 ve ertesi gün 00:00–02:00).",
  "plan.closedDates": "Kapalı günler",
  "plan.closedDates.hint": "Tatil gibi günler. Bütün numaralar o gün boyunca kapalı sayılır (her numara kendi saat dilimine göre); mesai dışında ne olacağını her numaranın kendi ayarı belirler. Her yıl yeniden eklenir.",
  "plan.closedDates.add": "Ekle",
  "plan.closedDates.empty": "Kapalı gün eklenmedi.",
  "plan.closedDates.workspaceNote": "Kapalı günler (tatil) bütün numaralar için ortaktır; sayfanın altındaki \"Kapalı günler\" kartından eklenir.",
  "plan.after": "Mesai dışında gelen aramalar",
  "plan.after.same": "Aynı ajan cevaplasın",
  "plan.after.same.hint": "Bugünkü gibi. Ajan mesai dışında olduğunu bilmez; bir kişiye telefonla aktarma denenmez, ajan not alır.",
  "plan.after.agent": "Başka bir ajan cevaplasın",
  "plan.after.agent.hint": "Örneğin yalnız not alan bir ajan. Ne söyleyeceği, yasal açıklamaları dahil, o ajanın kendi ayarlarındadır. O ajan cevaplayamazsa (yayında değil, kredi yok) asıl ajan cevaplar.",
  "plan.after.agent.pick": "Ajan seçin",
  "plan.after.agent.noHours": "Bu ajanın kendi arama saatleri yok: söz verdiği geri aramaları her saatte yapabilir. Ajan → Eylemler sekmesinden ayarlayın.",
  "plan.after.agent.noNumber": "Bu ajan numaralarınızın hiçbirinden aramıyor; geri aramaları platformun varsayılan numarasından yapılır.",
  "plan.after.refuse": "Cevaplanmasın",
  "plan.after.refuse.hint": "Arama ajana gitmez ve görüşme kaydı açılmaz; yalnız sayısı tutulur, kimin aradığı tutulmaz. Arayanın ne duyacağını aşağıdan seçin.",
  "plan.refuse.style": "Arayan ne duysun?",
  "plan.refuse.ring": "Çalsın, kimse açmasın",
  "plan.refuse.ring.hint": "kapalı bir ofis gibi; ücret yazılmaz. Süre dolunca operatör kendi anonsunu çalabilir.",
  "plan.refuse.message": "Kapalıyız mesajı okunsun",
  "plan.refuse.message.hint": "arama açılır, aşağıdaki mesaj ajanın sesiyle okunur ve kapanır; hat dakikası yazılır.",
  "plan.refuse.reject": "Hemen reddedilsin",
  "plan.refuse.reject.hint": "arama açılmadan reddedilir; operatör \"dahili numara kullanılamaz\" gibi bir anons çalar.",
  "plan.refuse.message.placeholder": "Örnek: Şu an mesai saatlerimiz dışındayız. Hafta içi 09:00–18:00 arasında bize ulaşabilirsiniz.",
  "plan.refuse.message.note": "Kaydedince bir kez seslendirilir. Kalan: {n} karakter.",
  "plan.refuse.message.listen": "Kaydedilmiş mesajı dinle",
  "plan.refused": "Mesai dışında reddedilen: bugün {today}, son 7 gün {week}",
  "plan.preview": "Şimdi {day} {time} ({zone}): {state}. {answer}",
  "plan.preview.note": "(Kaydedilmiş plana göre; değişiklikler kaydedince görünür.)",
  "plan.state.open": "açık",
  "plan.state.closed": "kapalı",
  "plan.state.holiday": "kapalı gün",
  "plan.answer.agent": "{agent} cevaplar.",
  "plan.answer.nobody": "Arama cevaplanmaz.",
  "plan.invalid.window": "Bitiş başlangıçtan sonra olmalı; aralıklar çakışmamalı.",
  "plan.invalid.empty": "En az bir gün için saat girin.",
  "plan.remove": "Saatleri kaldır",
  "calls.afterHours": "Mesai dışı",
  "calls.closedDay": "Kapalı gün",
  "numbers.accounts": "Bağlı SIP hesapları",
  "numbers.accounts.hint": "Bir işletme birden fazla hesap bağlayabilir; her hesapta birden fazla numara olabilir.",
  "numbers.count": "{n} numara",
  "lines.test": "Test et",
  "lines.connectTest": "Bağlan ve test et",
  "lines.test.again": "Tekrar test et",
  "lines.test.busy": "Bağlanıyor…",
  "lines.test.running": "Sağlayıcıya bağlanılıyor… ({s} sn)",
  "lines.test.ok": "Bağlantı başarılı: hat sağlayıcıya kayıt oldu. Devam edebilirsiniz.",
  "lines.test.rejected": "Sağlayıcı kullanıcı adını veya şifreyi reddetti. Bilgileri düzeltip tekrar test edin.",
  "lines.test.waiting": "Sağlayıcıdan henüz cevap gelmedi. Devam edebilirsiniz; bağlantı durumu listede görünecek.",
  "lines.test.unknown": "Bağlantı durumu şu an okunamadı. Devam edebilirsiniz; durum listede görünecek.",
  "lines.invalid.host": "“SIP sunucusu” geçersiz: küçük harfli bir alan adı (ör. sip.verimor.com.tr) ya da IP adresi yazın; http:// ve boşluk olmadan.",
  "lines.invalid.username": "“SIP kullanıcı adı” geçersiz: boşluk ve şu karakterler olamaz: @ ; : # % \" < > [ ] \\",
  "lines.invalid.authUsername": "“Kimlik doğrulama kullanıcısı” geçersiz: boşluk ve şu karakterler olamaz: @ ; : # % \" < > [ ] \\",
  "lines.invalid.password": "“SIP şifresi” geçersiz: en fazla 128 karakter; boşluk ve ters eğik çizgi (\\) olamaz.",
  "lines.invalid.port": "“Port” 1 ile 65535 arasında olmalı.",
  "error.LINE_EXISTS": "Bu SIP hesabı (aynı sunucu ve kullanıcı adı) platformda zaten bağlı. Aynı hesabı ikinci kez eklemek mevcut bağlantıyı düşürür; listedeki hattı kullanın.",
  "numbers.sameAccount": "Bu SIP hesabı zaten bağlı (“{name}”). Listedeki hattı seçtim; bağlantısını test ediyorum.",
  "numbers.alreadyListed": "Bu numara zaten listenizde. Gelen aramayı cevaplayan ajanı ve arayan ajanları numaralar tablosundan seçebilirsiniz.",
  "agent.tab.routing": "Yönlendirme",
  "routing.title": "Konuya göre yönlendirme",
  "routing.hint": "Arayanların sorduğu konuları kendi cümlelerinizle yazın ve her konunun nereye gideceğini seçin. Ajan arayanın ne istediğini anlar, gerekirse tek bir soru sorar. Sonra aramayı seçtiğiniz ajana ya da numaraya aktarır veya not alır. Liste boşsa ajan her aramayı kendisi karşılar.",
  "routing.empty": "Henüz konu yok. Karşılama ajanı için konuları ekleyin (ör. Rezervasyon, Fatura, Teknik destek).",
  "routing.topic": "Konu",
  "routing.topic.placeholder": "Konu adı (ör. Rezervasyon)",
  "routing.description": "Kapsadığı şeyler",
  "routing.description.placeholder": "Bu konuda arayanlar ne ister? (ör. yeni oda ayırtma, tarih değişikliği, iptal)",
  "routing.target": "Nereye",
  "routing.target.self": "Ajan kendisi not alsın",
  "routing.target.agent": "AI ajana devret: {name}",
  "routing.target.phone": "Telefon numarasına aktar",
  "routing.phone": "Aktarılacak numara",
  "routing.add": "Konu ekle",
  "routing.needCallback": "“Ajan kendisi not alsın” seçili konular için Eylemler sekmesinde geri aramayı açın; ajan arayanla dönüş zamanını kararlaştırabilsin.",
  "routing.badPhone": "Aktarılacak numarayı ülke koduyla yazın (+90…).",
  "routing.phoneNote": "Numaraya aktarma, aramanın geldiği hattan yapılır. Cevap gelmezse (meşgul, mesai dışı) arama ajana döner; ajan özür diler, konuyu ve dönüş zamanını not alır.",
  "routing.phone.placeholder": "+90 5xx xxx xx xx",
  "routing.summary": "Aktarılan: {connected}/{total} konu · Ajanın not aldığı: {message} konu",
  "routing.allMessage": "Hiçbir konu arayanı birine bağlamıyor; ajan her konuda not alır.",
  "routing.notPublished": "Seçilen ajan henüz yayında değil, aramalar ona aktarılamaz. Yayınlanana kadar bu konuda bu ajan not alır.",
  "studio.askingNow": "Şimdi soruluyor",
  "fieldHelp.identity.brandName": "Ajan her aramada bu işletme adına konuştuğunu söyler.",
  "fieldHelp.identity.name": "Ajan telefonda kendini bu adla tanıtır (“Ben Elif”). Sıcak bir isim ya da markanıza uygun bir ad seçin.",
  "fieldHelp.identity.persona": "Ajanın nasıl biri gibi konuşacağı: ör. “güler yüzlü, sabırlı danışman” ya da “hızlı ve net asistan”.",
  "fieldHelp.languages.primary": "Ajanın telefonda konuşacağı ve anlayacağı dil.",
  "fieldHelp.direction": "Ajan müşterileri mi arayacak (giden), yoksa işletmenizi arayanları mı karşılayacak (gelen)? Açılış cümlesi buna göre değişir.",
  "fieldHelp.mission.goal": "Her aramada ulaşmaya çalışacağı hedef; konuşmayı bu yöne götürür. Ör. “randevu almak”.",
  "fieldHelp.mission.audience": "Kimlerle konuşacağı; kelimelerini ve örneklerini onlara göre seçer.",
  "fieldHelp.mission.successCondition": "İyi bir aramanın ölçüsü (ör. randevu alındı). Görüşme özetleri ve raporlar buna göre değerlendirilir.",
  "fieldHelp.facts": "Görüşmede öğrenilecek bilgiler (ör. ad, ihtiyaç, uygun zaman). Görüşme kartında ve raporlarda görünür.",
  "fieldHelp.style.tone": "Konuşmanın havası: ör. “samimi ve kısa”, “resmî ve nazik”. Her cümleye uygulanır.",
  "fieldHelp.compliance.require[recording_notice].instruction": "Aramanın kaydedildiğini söyleyen cümle. Birçok ülkede yasal zorunluluk; her aramanın başında söylenir.",
  "fieldHelp.compliance.require[ai_disclosure].instruction": "Karşıdakine yapay zekâ asistanıyla konuştuğunu söyleyen cümle; kimse yanıltılmasın diye başta söylenir.",
  "fieldHelp.globalIntents[opt_out].description": "Birinin “beni bir daha aramayın” dediğini nasıl anlayacağı; o numara bir daha hiç aranmaz.",
  "lang.label": "Dil",
  "crash.title": "Bu sayfada bir hata oluştu",
  "crash.hint": "Sayfayı yenileyin. Tekrarlarsa aşağıdaki metni destek ekibine iletin.",
  "crash.reload": "Sayfayı yenile",
  "nav.testRoom": "Test odası",
  "room.title": "Test odası",
  "room.subtitle": "Ajanınızı sanal bir müşteriyle gerçek sesle konuşturun. Görüşme gerçek bir arama gibi kaydedilir; telefon hattı ve dakika kullanılmaz.",
  "room.agent": "Denenecek ajan",
  "room.noAgents": "Yayınlanmış ajan yok. Önce bir ajanı yayınlayın.",
  "room.direction": "Görüşme yönü",
  "room.direction.outbound": "Ajan müşteriyi arar",
  "room.direction.inbound": "Müşteri işletmeyi arar",
  "room.persona": "Müşteri tipi",
  "room.persona.interested": "İlgili",
  "room.persona.interested.hint": "Soruları cevaplar, pratik sorular sorar; net bir teklif gelirse kabul eder.",
  "room.persona.busy": "Meşgul",
  "room.persona.busy.hint": "İşinin ortasında; çok kısa cevaplar, çabuk bir geri arama teklifini kabul eder.",
  "room.persona.skeptical": "Şüpheci",
  "room.persona.skeptical.hint": "Numarasını nereden aldığınızı, ne sattığınızı ve fiyatı sorar; net cevap ister.",
  "room.persona.rude": "Kaba",
  "room.persona.rude.hint": "Aramadan rahatsız; kısa ve sert. Ajanın sakin kalıp kalmadığını ölçer.",
  "room.persona.refusal": "Reddeden",
  "room.persona.refusal.hint": "İlgilenmediğini açıkça söyler; ajanın saygıyla kapatıp kapatmadığını ölçer.",
  "room.persona.confused": "Kafası karışık",
  "room.persona.confused.hint": "Ne anlatıldığını anlamaz, tekrar sorar; sade anlatımı ölçer.",
  "room.persona.competitor_happy": "Rakipten memnun",
  "room.persona.competitor_happy.hint": "Başka bir firmayla çalışıyor ve memnun; ajanın farkını anlatabilmesini ölçer.",
  "room.scenario": "Müşterinin durumu (isteğe bağlı)",
  "room.scenario.placeholder": "Örn. Yarın için rezervasyonu var, iptal etmek istiyor ama ücret ödemek istemiyor.",
  "room.scenario.hint": "Kendi müşterilerinizden gerçek bir durumu yazın; sanal müşteri bunu yaşıyormuş gibi konuşur.",
  "room.voice": "Müşterinin sesi",
  "room.voice.default": "Platform varsayılanı",
  "room.start": "Görüşmeyi başlat",
  "room.starting": "Başlatılıyor…",
  "room.cost": "Telefon dakikası harcanmaz; yalnız yapay zekâ kullanımı hesabınıza yazılır.",
  "room.history": "Son görüşmeler",
  "room.empty": "Henüz test görüşmesi yok.",
  "room.pick": "Soldan bir görüşme başlatın ya da listeden birini seçin.",
  "room.running": "Görüşme sürüyor… Bitince kayıt ve konuşma dökümü burada açılır.",
  "room.failed": "Görüşme başlatılamadı. Biraz sonra tekrar deneyin.",
  "room.status.created": "Başlıyor",
  "room.status.live": "Sürüyor",
  "room.status.ended": "Bitti",
  "room.status.failed": "Başarısız",
  "room.heard.title": "Ajan doğru duydu mu?",
  "room.heard.hint": "Solda müşterinin söylediği, sağda ajanın duyduğu. Farklar ses tanıma hatalarını gösterir.",
  "room.heard.said": "Müşteri söyledi",
  "room.heard.heard": "Ajan duydu",
  "room.heard.none": "(duyulmadı)",
  "error.ROOM_NOT_CONFIGURED": "Test odası bu kurulumda kapalı.",
  "nav.room": "Test odası",
  "templates.agentLanguage": "Ajanın konuşacağı dil",
  "templates.language.tr-TR": "Türkçe",
  "templates.language.en-US": "İngilizce",
  "templates.language.ar-SA": "Arapça",
  "templates.sector": "Sektör",
  "templates.structure": "Arama yapısı",
  "templates.direction": "Arama yönü",
  "templates.all": "Tümü",
  "templates.own": "Sizin şablonunuz",
  "templates.otherLanguage": "Bu dilde yok ({lang} gösteriliyor)",
  "templates.none": "Bu seçime uyan şablon yok. Filtreleri değiştirin ya da boş başlayın.",
  "templates.filled": "Şablon, işletme bilgilerinizle dolduruldu: {list}.",
  "templates.unresolved": "Bilgi kaynağınızda bulunamayanlar (gerekirse Stüdyo soracak): {list}.",
  "templates.var.business.name": "işletme adı",
  "templates.var.business.website": "web sitesi",
  "templates.var.business.phone": "telefon",
  "templates.var.business.email": "e-posta",
  "templates.var.business.address": "adres",
  "templates.var.business.city": "şehir",
  "templates.var.business.hours": "çalışma saatleri",
  "templates.var.business.offer": "sunduğunuz ürün/hizmet",
  "sector.general": "Genel",
  "sector.hospitality": "Otel ve konaklama",
  "sector.healthcare": "Sağlık ve klinik",
  "sector.insurance": "Sigorta",
  "sector.real_estate": "Emlak",
  "sector.b2b_supply": "B2B satış ve tedarik",
  "sector.ecommerce": "E-ticaret ve kargo",
  "sector.education": "Eğitim ve kurs",
  "sector.automotive": "Otomotiv ve servis",
  "structure.receptionist": "Karşılama ve yönlendirme",
  "structure.support": "Müşteri desteği",
  "structure.appointment": "Randevu",
  "structure.sales": "Satış araması",
  "structure.lead_qualification": "Aday değerlendirme",
  "structure.survey": "Memnuniyet anketi",
  "structure.reminder": "Hatırlatma",
  "structure.follow_up": "Takip araması",
  "structure.renewal": "Yenileme",
  "templates.panel.title": "Şablon",
  "templates.panel.none": "Bu ajan bir şablondan üretilmedi.",
  "templates.save": "Şablon olarak kaydet",
  "templates.save.hint": "Bu ajanın ayarları kendi şablonunuz olur; yalnız siz görürsünüz ve yeni ajanları ondan üretebilirsiniz.",
  "templates.save.newVersion": "Bu ajan sizin şablonunuzdan: kaydetmek şablonun yeni sürümünü oluşturur.",
  "templates.save.name": "Şablon adı",
  "templates.save.description": "Kısa açıklama",
  "templates.save.changelog": "Bu sürümde ne değişti?",
  "templates.save.button": "Kaydet",
  "templates.save.done": "Şablon kaydedildi (sürüm {v}).",
  "templates.update.title": "Şablonun yeni sürümü var: v{v}",
  "templates.update.apply": "Güncellenecek alanlar: {list}.",
  "templates.update.keep": "Sizin değiştirdiğiniz, korunacak alanlar: {list}.",
  "templates.update.hint": "Ajan canlıda kendiliğinden değişmez: uyguladıktan sonra yayınlamanız gerekir.",
  "templates.update.button": "v{v} sürümünü uygula",
  "templates.update.done": "v{v} uygulandı ({n} alan güncellendi). Yayınlamayı unutmayın.",
  "templates.field.mission.goal": "Görüşmenin amacı",
  "templates.field.mission.successCondition": "Başarı ölçütü",
  "templates.field.mission.audience": "Kimlerle konuşulur",
  "templates.field.style.tone": "Konuşma tonu",
  "templates.field.style.maxSentencesPerTurn": "Cevap uzunluğu",
  "templates.field.facts": "Toplanacak bilgiler",
  "templates.field.boundaries.blockedTopics": "Konuşulmayacak konular",
  "templates.field.boundaries.mustNotPromise": "Asla söz verilmeyecekler",
  "templates.field.globalIntents.extra": "Özel durumlar",
  "templates.field.statements.extra": "İşletme cevapları",
  "templates.field.routes": "Yönlendirme konuları",
  "error.TEMPLATE_UP_TO_DATE": "Ajan zaten şablonun son sürümünde.",
  "error.TEMPLATE_NOT_LINKED": "Bu ajan bir şablona bağlı değil.",
  "nav.readyAgents": "Hazır ajanlar",
  "nav.templates": "Hazır ajanlar",
  "ready.title": "Hazır ajanlar",
  "ready.subtitle": "Dil, sektör ve arama yönüne göre hazır bir ajan seçin; işletme bilgilerinizle doldurulur, tek adımda oluşturulur.",
  "ready.toStudio": "Sohbetle sıfırdan kur",
  "ready.loading": "İşletme bilgileriniz okunuyor…",
  "ready.goal": "Ajan ne yapar",
  "ready.collects": "Toplayacağı bilgiler",
  "ready.routes": "Yönlendireceği konular",
  "ready.answers": "İşletmeniz adına vereceği cevaplar",
  "ready.never": "Asla söz vermeyecekleri",
  "ready.name": "Ajanın adı",
  "ready.contactSource": "Aradığınız numaralar nereden geliyor?",
  "ready.contactSource.placeholder": "Örn. Bizimle daha önce iletişime geçen müşterilerimiz",
  "ready.contactSource.hint": "Müşteri \"numaramı nereden aldınız?\" diye sorarsa ajan bunu söyler. Doğru olmalı; bu yüzden sizden istiyoruz.",
  "ready.optional": "isteğe bağlı",
  "ready.incomplete": "Bu şablon eksik alan içeriyor; lütfen Stüdyo ile kurun.",
  "ready.create": "Ajanı oluştur",
  "ready.creating": "Oluşturuluyor…",
  "ready.after": "Ajan oluşunca satış kiti otomatik hazırlanır; sonra test edip yayınlarsınız. Her şeyi daha sonra değiştirebilirsiniz.",
  "ready.fromStudio": "Hazır ajanlardan seç",
  "ready.fromStudio.hint": "Sektörünüze uygun, işletme bilgilerinizle doldurulan hazır ajanlar; soru sormadan tek adımda.",
  "error.TEMPLATE_INPUT_MISSING": "Oluşturmak için eksik bilgi var.",
  "nav.stats": "İstatistikler",
  "stats.title": "İstatistikler",
  "stats.subtitle": "Ajanlarınızın ne yaptığı ve size ne kazandırdığı. Yalnız gerçek görüşmeler sayılır; test görüşmeleri dahil değildir.",
  "stats.period": "Dönem",
  "stats.lastDays": "Son {n} gün",
  "stats.agent": "Ajan",
  "stats.allAgents": "Tüm ajanlar",
  "stats.allDirections": "Gelen + giden",
  "stats.empty": "Bu dönemde gerçek görüşme yok. Bir kampanya başlatın ya da numaranızı bir ajana bağlayın.",
  "stats.kpi.calls": "Görüşme",
  "stats.kpi.answered": "%{p} açıldı",
  "stats.kpi.talked": "Gerçekleşen görüşme",
  "stats.kpi.avg": "ortalama {d} dk",
  "stats.kpi.minutes": "Konuşma dakikası",
  "stats.kpi.minutesNote": "açılan görüşmelerin toplamı",
  "stats.kpi.hot": "Sıcak müşteri",
  "stats.kpi.hotNote": "görüşmelerin %{p}'i · {warm} ılık",
  "stats.kpi.callbacks": "Geri arama",
  "stats.kpi.callbacksNote": "kararlaştırılan sonraki arama",
  "stats.kpi.optOuts": "\"Aramayın\" diyen",
  "stats.kpi.optOutsNote": "açılanların %{p}'i · listeye eklendi",
  "stats.kpi.machine": "Sesli mesaj",
  "stats.kpi.machineNote": "ajan bekletmeden kapattı",
  "stats.kpi.mood": "Olumlu ton",
  "stats.kpi.moodNote": "{n} olumsuz görüşme",
  "stats.daily.title": "Günlük görüşmeler ve sonuçları",
  "stats.daily.hint": "Her gün kaç görüşme oldu, müşteriler ne kadar ilgilendi.",
  "stats.showTable": "Tablo olarak göster",
  "stats.showChart": "Grafik olarak göster",
  "stats.seg.hot": "Sıcak",
  "stats.seg.warm": "Ilık",
  "stats.seg.cold": "Soğuk",
  "stats.seg.notReached": "Ulaşılamadı",
  "stats.seg.unscored": "Değerlendirilmedi",
  "stats.col.day": "Gün",
  "stats.col.answered": "Açılma",
  "stats.col.avg": "Ort. süre",
  "stats.funnel.title": "Arama hunisi",
  "stats.funnel.hint": "Aranandan sonraki adıma kadar kaç kişi kaldı.",
  "stats.funnel.dialed": "Arandı",
  "stats.funnel.answered": "Açtı",
  "stats.funnel.talked": "Konuştu",
  "stats.funnel.interested": "İlgilendi",
  "stats.funnel.next": "Sonraki adım",
  "stats.funnel.ofFirst": "aranların %{p}'i",
  "stats.heat.title": "Gün ve saate göre yoğunluk",
  "stats.heat.hint": "Koyu kareler daha çok görüşme demek. Giden aramalarda en çok açılan saatleri, gelende en yoğun saatleri gösterir.",
  "stats.heat.read": "{n} görüşme, {a} açıldı",
  "stats.heat.hover": "Ayrıntı için bir karenin üzerine gelin.",
  "stats.agents.title": "Ajanlara göre",
  "stats.topics.title": "Arayanların konuları",
  "stats.topics.hint": "Karşılama ajanının yönlendirdiği konular.",
  "stats.dow.1": "Pzt",
  "stats.dow.2": "Sal",
  "stats.dow.3": "Çar",
  "stats.dow.4": "Per",
  "stats.dow.5": "Cum",
  "stats.dow.6": "Cmt",
  "stats.dow.7": "Paz",
  "stats.usage.title": "Kullanım ve maliyet",
  "stats.usage.rates": "Görüşme başına {c} kredi + her başlayan dakika için {m} kredi (Panaryus paketinize göre).",
  "stats.usage.unavailable": "Paket bilgisine şu an ulaşılamadı; yalnız ücretlenen dakikalar gösteriliyor.",
  "stats.usage.billable": "Ücretlenen dakika",
  "stats.usage.billableNote": "{n} açılan görüşme, dakikalar yukarı yuvarlanır",
  "stats.usage.spent": "Bu dönemde harcanan kredi",
  "stats.usage.spentNote": "görüşme + dakika kredisi",
  "stats.usage.perHot": "Sıcak müşteri başına",
  "stats.usage.perHotNote": "kredi",
  "stats.usage.perCallback": "Geri arama başına",
  "stats.usage.perCallbackNote": "kredi",
  "stats.usage.credits": "Kalan kredi",
  "stats.usage.creditsNote": "Panaryus hesabınızda",
  "stats.usage.plan": "Paket: {plan} — sesli arama dakikası",
  "stats.usage.minutes": "{used} / {limit} dk",
  "stats.usage.unlimited": "{used} dk (sınırsız)",
  "stats.usage.near": "Paket dakikanızın %90'ından fazlası kullanıldı. Dolunca aramalar durur; paketinizi yükseltmeyi düşünün.",
  "stats.campaigns.title": "Kampanyaları karşılaştır",
  "stats.campaigns.hint": "Hangi liste ve ajan, harcanan krediye göre en çok ilgili müşteriyi getirdi. Sıcak müşteri oranı, konuşulan görüşmelere göredir.",
  "stats.campaigns.name": "Kampanya",
  "stats.campaigns.list": "Ulaşılan / liste",
  "stats.campaigns.hotRate": "Sıcak müşteri",
  "stats.campaigns.credits": "Kredi",
  "stats.campaigns.best": "En iyi",
  "create.hero.title": "Hadi, size uygun ajanı kolayca oluşturalım",
  "ready.hero.body": "Sektörünüze uygun hazır bir ajanı seçin; işletme bilgilerinizle dolar, tek adımda hazır olur. Aradığınızı bulamazsanız ne istediğinizi yazın, birlikte bulalım.",
  "studio.hero.body": "Ne istediğinizi anlatın, yapay zekâ adım adım sorsun ve ajanınızı birlikte kuralım. Daha hızlısı: sektörünüze uygun hazır ajanlardan birini seçin.",
  "studio.hero.start": "Sohbetle kurmaya başla",
  "ready.finder.open": "Bulamadın mı? Hızlıca çözüm bulalım",
  "ready.finder.title": "Size uygun ajanı bulalım",
  "ready.finder.ask": "Ajanınız ne yapsın? Kendi cümlenizle yazın; örn. \"Diş kliniğimi arayanları karşılasın, randevu alsın.\" ya da \"Eski müşterilerimi arayıp yeni kampanyayı anlatsın.\"",
  "ready.finder.placeholder": "Ajanın ne yapmasını istiyorsunuz?",
  "ready.finder.use": "Bu ajanı seç",
  "ready.finder.noneFit": "Bunlar uymadı mı?",
  "ready.finder.noMatch": "Hazır ajan bulunamadı, sizin için özel kuralım.",
  "ready.finder.custom": "Sohbetle özel ajan kur",
  "ready.finder.close": "Kapat",
  "nav.group.platform": "Platform",
  "nav.templateNeeds": "Şablon ihtiyaçları",
  "nav.needs": "Şablon ihtiyaçları",
  "platform.needs.title": "Şablon ihtiyaçları",
  "platform.voice.title": "Türkçe ses (EMA)",
  "platform.voice.on": "Çalışıyor",
  "platform.voice.off": "Kapalı",
  "platform.voice.unreachable": "Ulaşılamıyor",
  "platform.voice.load": "Kullanımda {active}/{max} · okunan {served} · meşgul reddi {busy}",
  "platform.voice.lastHour": "Son 1 saat: EMA'da {emaCalls} görüşme, {fellBack} görüşme yedek sese geçti ({fallbacks} geçiş) · tüm görüşmelerde ses hatası: {failed}",
  "platform.needs.subtitle": "İşletmelerin \"Bulamadın mı?\" ile ne istediği — tüm işletmelerin toplamı, yalnız etiket ve sayı (işletme ya da yazdıkları görünmez). Hazır ajan bulunamayanlar en üstte: yazılacak yeni şablonlar.",
  "platform.needs.empty": "Bu dönemde bulucu kullanılmadı.",
  "platform.needs.industry": "Sektör",
  "platform.needs.callType": "Arama türü",
  "platform.needs.requests": "İstek",
  "platform.needs.businesses": "İşletme",
  "platform.needs.noMatch": "Hazır ajan yok",
  "platform.needs.choseTemplate": "Öneri seçildi",
  "platform.needs.choseCustom": "Özel kuruldu",
  "platform.needs.write": "Şablon yazılmalı",
  "platform.needs.hint": "\"Şablon yazılmalı\": en az 2 işletme istedi ve en az 3 kez hazır ajan bulunamadı. Sektör ve arama türü, yapay zekânın kısa İngilizce etiketleridir.",
  "error.PLATFORM_ADMIN_ONLY": "Bu ekran yalnız platform yöneticileri içindir.",
  "agent.tab.readiness": "Hazırlık",
  "readiness.title": "Ajan hazırlığı: %{score}",
  "readiness.subtitle": "Arayanların soracağı sorular ve birkaç ayar. Cevapladıkça ajanınız daha çok soruyu kendisi yanıtlar; cevapsız soruda \"sizi arayalım\" der.",
  "readiness.publishNote": "Kaydettiğiniz cevaplar taslağa girer; yayınladığınızda canlı görüşmelerde kullanılır. Doldurmasanız da ajan çalışır.",
  "readiness.suggest.none": "Bu ajan hazır şablondan gelmediği için soru listesi yok. Yapay zekâ işinize göre soru önerebilir.",
  "readiness.suggest.more": "İşinize özel başka sorular da ekletebilirsiniz.",
  "readiness.suggest.button": "Yapay zekâ soru önersin",
  "readiness.suggest.running": "Sorular hazırlanıyor…",
  "readiness.group.missing": "Eksik ({n})",
  "readiness.group.done": "Tamam ({n})",
  "readiness.group.dismissed": "Bizde yok ({n})",
  "readiness.impact.high": "Çok önemli",
  "readiness.impact.medium": "Önemli",
  "readiness.impact.low": "Faydalı",
  "readiness.fill": "Yapay zekâyla doldur",
  "readiness.edit": "Düzenle",
  "readiness.dismiss": "Bizde yok",
  "readiness.undismiss": "Geri al",
  "readiness.setting.go": "Ayarla",
  "readiness.setting.hours.title": "Çalışma saatleri ve saat dilimi",
  "readiness.setting.hours.why": "Ajan hangi saatlerde arayacağını, \"açık mısınız\" sorusunu ve geri arama saatini buna göre belirler.",
  "readiness.setting.voice.title": "Ajanın sesi",
  "readiness.setting.voice.why": "Markanıza uygun bir ses, arayanın güvenini ve görüşme süresini artırır.",
  "readiness.setting.transfers.title": "Aktarma numaraları",
  "readiness.setting.transfers.why": "Müşteri bir yetkiliyle görüşmek istediğinde ajan aramayı bu numaralara aktarır; yoksa sadece not alır.",
  "readiness.setting.routing_unreachable.title": "Konuların gittiği ajanların yayını",
  "readiness.setting.routing_unreachable.why": "Yayında olmayan bir ajana yönlendirilen konu ona hiç ulaşmaz; arama not almaya döner. O ajanı yayınlayın ya da başka bir hedef seçin.",
  "readiness.setting.routing_callback.title": "Not alınan konular için geri arama",
  "readiness.setting.routing_callback.why": "Bu konularda ajan not alır. Geri aramayı açın ki arayanla dönüş zamanını da kararlaştırabilsin.",
  "readiness.setting.contact_source.title": "Kişileri nereden bulduğunuz",
  "readiness.setting.contact_source.why": "\"Numaramı nereden buldunuz?\" sorusu giden aramalarda en sık sorulandır; net cevap vermeyen ajan güven kaybeder.",
  "readiness.card.title": "Ajan hazırlığı %{score}",
  "readiness.card.open": "Eksikleri tamamla",
  "readiness.card.high": "{n} çok önemli bilgi eksik (toplam {total}). Ajan çalışıyor ama bu sorularda \"sizi arayalım\" diyecek.",
  "readiness.card.some": "{n} bilgi eksik. Tamamladıkça ajan daha çok soruyu kendisi yanıtlar.",
  "readiness.assist.placeholder": "Cevabı kendi sözlerinizle yazın (ör. fiyatlar, saatler, koşullar)…",
  "readiness.assist.draft": "Ajanın söyleyeceği cevap",
  "readiness.assist.draftPlaceholder": "Buraya doğrudan kendiniz de yazabilirsiniz.",
  "readiness.assist.draftHint": "Ajan bu cümleyi aynen kullanır. Yapay zekâ bilmediği rakam ya da bilgi uydurmaz.",
  "readiness.assist.save": "Kaydet",
  "overview.att.readiness": "{name}: {n} önemli bilgi eksik",
  "overview.att.readiness.body": "Ajan çalışıyor (hazırlık %{score}) ama bu sorularda müşteriye net cevap veremiyor.",
  "overview.att.readiness.cta": "Eksikleri tamamla",
  "readiness.assist.opening": "Bilgilerinizde bu konuda bir şey bulamadım. Müşteri \"{question}\" diye sorduğunda ne cevap verilsin? Kendi sözlerinizle kısaca yazın, ben ajanın söyleyeceği cümleye çevireyim.",
  "stats.unanswered.title": "Ajanın cevaplayamadığı sorular",
  "stats.unanswered.hint": "Gerçek görüşmelerde müşterilerin sorup ajanın net cevap veremediği sorular. Cevabı eklediğinizde ajan bir dahakine kendisi yanıtlar.",
  "stats.unanswered.open": "{n} soru cevap bekliyor",
  "stats.unanswered.empty": "Henüz yok. Bundan sonraki görüşmeler bittikçe burada toplanır.",
  "stats.unanswered.question": "Soru",
  "stats.unanswered.calls": "Görüşme",
  "stats.unanswered.lastCall": "Son görüşmeyi aç",
  "stats.unanswered.add": "Cevabı ekle",
  "stats.unanswered.done": "Cevap eklendi",
  "stats.unanswered.why": "Müşteriler gerçek görüşmelerde {n} kez sordu, ajan cevaplayamadı. Cevap eklenince ajan bu soruyu kendisi yanıtlar.",
  "stats.endings.title": "Görüşmeler nerede bitti?",
  "stats.endings.hint": "Konuşulan görüşmelerin hangi aşamada sona erdiği ve kaçında müşterinin kapattığı. Müşterinin en çok kapattığı aşama, iyileştirilecek yerdir.",
  "stats.endings.empty": "Bu dönemde yeterince uzun görüşme yok.",
  "stats.endings.row": "{n} görüşme · müşteri kapattı {c} · ilgilenen {i}",
  "stats.endings.hungUp": "müşteri kapattı {n}",
  "stats.stage.opening": "Açılış",
  "stats.stage.discovery": "İhtiyacı anlama",
  "stats.stage.pitch": "Teklif",
  "stats.stage.objection": "İtiraz",
  "stats.stage.closing": "Kapanış",
  "stats.stage.ended": "Bitti",
  "stats.endings.advice.opening": "{n} müşteri daha açılışta kapattı. İlk cümleyi kısaltıp arama sebebini hemen söylemek genelde en çok fark yaratan değişikliktir.",
  "stats.endings.advice.discovery": "{n} müşteri ihtiyaç sorularında kapattı. Daha az ve daha kısa soru sormayı deneyin.",
  "stats.endings.advice.pitch": "{n} müşteri teklif sırasında kapattı. Teklifi tek, net bir faydayla anlatmayı ve satış kitini güncellemeyi deneyin.",
  "stats.endings.advice.objection": "{n} müşteri itirazdan sonra kapattı. Sık itirazlara hazır cevapları satış kitine ekleyin.",
  "stats.cb.title": "Geri arama sözleri",
  "stats.cb.hint": "Ajanın müşteriye verdiği geri arama sözleri tutuldu mu? Zamanında arandı mı, müşteriye ulaşıldı mı?",
  "stats.cb.empty": "Bu dönemde geri arama sözü yok.",
  "stats.cb.summary": "{n} söz verildi · aranan {placed} sözün {onTime} tanesi zamanında (%{p})",
  "stats.cb.reached": "Arandı, ulaşıldı",
  "stats.cb.notReached": "Arandı, açmadı",
  "stats.cb.team": "Ekibiniz halletti",
  "stats.cb.waiting": "Saati bekleniyor",
  "stats.cb.late": "Gecikmiş",
  "stats.cb.failed": "Aranamadı",
  "stats.cb.manual": "Elle aranacak",
  "stats.cb.reached.hint": "Ajan söz verilen saatte aradı ve müşteri açtı.",
  "stats.cb.notReached.hint": "Ajan aradı ama müşteri açmadı ya da telesekreter çıktı.",
  "stats.cb.team.hint": "Ekibiniz \"tamamlandı\" olarak işaretledi.",
  "stats.cb.waiting.hint": "Saati henüz gelmedi; ajan otomatik arayacak.",
  "stats.cb.late.hint": "Saati 10 dakikadan fazla geçti ama arama yapılmadı.",
  "stats.cb.failed.hint": "Ajan aramayı başlatamadı; sebebi aşağıda.",
  "stats.cb.manual.hint": "Otomatik aranamayacak sözler (ör. saat belirsiz); ekibinizin araması gerekiyor.",
  "stats.cb.open": "Görüşmeyi aç",
  "stats.cb.error.PHONE_NOT_E164": "numara biçimi tanınmadı",
  "stats.cb.error.DO_NOT_CALL": "müşteri aranmamak istedi",
  "stats.cb.error.AGENT_NOT_PUBLISHED": "ajan yayında değil",
  "stats.cb.error.OUTSIDE_HOURS": "çalışma saatleri dışındaydı",
  "stats.cb.error.ORIGINATE_FAILED": "hat aramayı başlatamadı",
  "stats.cb.error.BILLING_PRINCIPAL_MISSING": "hesap bilgisi eksik",
  "stats.cb.error.other": "aranamadı",
  "agent.tab.offerings": "Ürünler",
  "offerings.title": "Ürün ve hizmetler",
  "offerings.subtitle": "Ajanın görüşmede tanıtacağı ürün ve hizmetler. Sıra önceliktir: ajan önce listedeki ilk uygun olanı anlatır.",
  "offerings.suggest": "Yapay zekâ bilgilerimden önersin",
  "offerings.suggesting": "Bilgileriniz okunuyor…",
  "offerings.rule.order": "Yukarıdaki ürün önce anlatılır; oklarla sırayı değiştirin.",
  "offerings.rule.outbound": "Giden aramada ajan önce kısaca ihtiyacı sorar, uygun ürünü anlatır; ilgi yoksa sıradakine geçer. Bir görüşmede en fazla 3 ürün.",
  "offerings.rule.inbound": "Gelen aramada müşterinin sorduğunu anlatır; başka bir ürünü yalnız uygunsa ve sona doğru önerir.",
  "offerings.rule.truth": "Ajan yalnız burada yazanı söyler; fiyat ya da koşul yazmadıysanız uydurmaz.",
  "offerings.found": "{n} ürün/hizmet bulundu — eklemek istediklerinizi seçin",
  "offerings.none": "Bilgilerinizde ürün ya da hizmet bulunamadı. Elle ekleyebilirsiniz.",
  "offerings.suggest.hint": "Yapay zekâ yalnız İşletme Beyni'nde yazanı önerir; kontrol edip kaydedin.",
  "offerings.addPicked": "{n} ürünü ekle",
  "offerings.empty": "Henüz ürün yok. Yapay zekâya önerin ya da elle ekleyin.",
  "offerings.rank": "Öncelik {n}",
  "offerings.summary.missing": "Açıklama eksik",
  "offerings.up": "Yukarı taşı",
  "offerings.down": "Aşağı taşı",
  "offerings.name": "Ad",
  "offerings.summary": "Ne olduğu (tek cümle)",
  "offerings.summary.hint": "Günlük dille; ajan bunu kendi sözleriyle söyler.",
  "offerings.benefits": "Faydalar (her satıra bir, en fazla 3)",
  "offerings.benefits.hint": "Müşteriye somut kazancı; ör. zaman, para, kolaylık.",
  "offerings.fits": "Kime / hangi ihtiyaca uygun",
  "offerings.terms": "Fiyat veya koşul (isteğe bağlı)",
  "offerings.terms.hint": "Fiyat ve koşul yazarsanız ajan aynen söyler; boş bırakırsanız fiyat sorulunca bilgi yok der.",
  "offerings.remove": "Bu ürünü kaldır",
  "offerings.add": "Ürün ekle",
  "offerings.new": "Yeni ürün",
  "offerings.unsaved": "Kaydedilmemiş değişiklik var",
  "offerings.publishNote": "Kaydettikten sonra ajanı yayınlayınca canlı görüşmelerde kullanılır.",
  "campaigns.focus": "Öne çıkacak ürünler",
  "campaigns.focus.hint": "İşaretlenenler bu kampanyada önce anlatılır; işaretlenmeyenler ajanın genel sırasıyla.",
  "campaigns.focus.none": "Bu ajanın ürün listesi yok; ajan sayfasındaki Ürünler sekmesinden ekleyebilirsiniz.",
  "campaigns.focus.default": "Ajanın genel sırası",
  "stats.offerings.title": "Ürün ilgisi",
  "stats.offerings.hint": "Ajanların görüşmelerde anlattığı ürün ve hizmetler; müşterinin ilgi gösterdiği ya da soğuk kaldığı.",
  "stats.offerings.item": "Ürün / hizmet",
  "stats.offerings.presented": "Anlatıldı",
  "stats.offerings.interest": "İlgi",
  "stats.offerings.cold": "Soğuk",
  "offerings.saved": "Ürünler kaydedildi. Canlı görüşmelerde kullanılması için ajanı yayınlayın.",
  "offerings.incomplete": "Kaydetmek için her ürünün adı ve açıklaması dolu olmalı: {names}",
  "greeting.title": "Açılış",
  "greeting.hint": "Ajan görüşmeyi nasıl açsın? Önce kısa bir selam verip müşterinin cevabını beklerse konuşma daha doğal başlar.",
  "greeting.full": "Tek cümlede tam açılış",
  "greeting.full.hint": "Selam, kim olduğu, yasal bildirimler ve arama sebebi ilk cümlede.",
  "greeting.greet": "Önce yalnız selam",
  "greeting.greet.hint": "İlk cümle yalnız selam; kendini tanıtma ve bildirimler müşterinin cevabından sonra.",
  "greeting.lines": "Selam cümleleri (her satıra bir, en fazla 5)",
  "greeting.lines.hint": "Her görüşmede sırayla biri söylenir. {brand} yazarsanız işletmenizin adı gelir.",
  "greeting.suggestions": "Öneriler:",
  "greeting.legal": "Yapay zekâ ve kayıt bildirimi ajanın ikinci cümlesinde, kendini tanıtırken söylenir.",
  "offerings.counts": "{v} varyant · {q} soru · {x} itiraz",
  "offerings.details.title": "Varyantlar ve ürün kiti",
  "offerings.details.hint": "Müşteri bu ürünle ilgilenince ajan uygun 1–2 varyantı önerir; soruları ve itirazları buradaki cevaplarla yanıtlar.",
  "offerings.details.fill": "Yapay zekâyla doldur",
  "offerings.details.found": "{n} öneri bulundu — eklemek istediklerinizi seçin",
  "offerings.details.none": "Bilgilerinizde bu ürün için öneri bulunamadı. Elle ekleyebilirsiniz.",
  "offerings.variant": "Varyant",
  "offerings.faq": "Soru",
  "offerings.objection": "İtiraz",
  "offerings.variants": "Varyantlar",
  "offerings.variant.name": "Ad (ör. marka, model, paket)",
  "offerings.variant.summary": "Kısa açıklama",
  "offerings.variant.terms": "Fiyat / koşul",
  "offerings.variant.add": "Varyant ekle",
  "offerings.faqs": "Sık sorulan sorular",
  "offerings.faq.q": "Müşterinin sorusu",
  "offerings.faq.a": "Ajanın cevabı",
  "offerings.faq.add": "Soru ekle",
  "offerings.objections": "İtirazlar",
  "offerings.objection.q": "Müşterinin itirazı",
  "offerings.objection.a": "Ajanın cevabı",
  "offerings.objection.add": "İtiraz ekle",
  "offerings.row.remove": "Kaldır",
  "nav.aiCalls": "Görüşmeler ve AI kullanımı",
  "platform.calls.title": "Görüşmeler ve yapay zekâ kullanımı",
  "platform.calls.subtitle": "Tüm işletmelerin tüm görüşmeleri: hangi yapay zekâ modelleri kullanıldı, kaç token harcandı ve tahmini model maliyeti. Ayrıntı için bir görüşmeye tıklayın.",
  "platform.calls.kind.all": "Tümü",
  "platform.calls.kind.real": "Gerçek görüşmeler",
  "platform.calls.kind.room": "Test odası",
  "platform.calls.room": "Test odası",
  "platform.calls.tenantFilter": "İşletme kimliği (örn. ten_pu_5432)",
  "platform.calls.onPage": "Bu sayfada",
  "platform.calls.inputTokens": "Giriş token",
  "platform.calls.outputTokens": "Çıkış token",
  "platform.calls.cached": "Önbellekten",
  "platform.calls.cost": "Tahmini maliyet",
  "platform.calls.empty": "Görüşme yok.",
  "platform.calls.date": "Tarih",
  "platform.calls.business": "İşletme",
  "platform.calls.agent": "Ajan",
  "platform.calls.customer": "Müşteri",
  "platform.calls.type": "Tür",
  "platform.calls.duration": "Süre",
  "platform.calls.turns": "Tur",
  "platform.calls.models": "Modeller",
  "platform.calls.model": "Model",
  "platform.calls.tokens": "Token (giriş/çıkış)",
  "platform.calls.hint": "Maliyet, fiyat tablosundan (templates/defaults/llm-prices.json) tahmindir; SuperGrok abonelik olduğu için 0. 28.09.2026 öncesi görüşmelerde kullanım kaydı yoktur.",
  "platform.calls.newer": "← Daha yeni",
  "platform.calls.older": "Daha eski →",
  "platform.calls.back": "Görüşmelere dön",
  "platform.calls.modelCalls": "Model çağrısı",
  "platform.calls.summary": "Özet",
  "platform.calls.scenario": "Test senaryosu",
  "platform.calls.modelsUsed": "Kullanılan modeller",
  "platform.calls.noUsage": "Bu görüşme için kullanım kaydı yok (28.09.2026 öncesi görüşmelerde bulunmaz).",
  "platform.calls.job": "İş",
  "platform.calls.avgTime": "Ort. süre",
  "platform.calls.unpriced": "Fiyat tablosunda olmayan: {models}",
  "platform.calls.conversation": "Görüşme",
  "platform.calls.conversationHint": "Her turda ajanın ne duyduğu ve ne söylediği, konuşmaya kaç saniyede başladığı ve turun token tutarı.",
  "platform.calls.noTurns": "Kayıtlı tur yok.",
  "platform.calls.firstWord": "ilk kelime {s} sn",
  "platform.calls.turnTokens": "token {in} → {out} (önbellekten {cached})",
  "platform.calls.critics": "denetim devreye girdi: {list}",
  "platform.calls.role.conductor": "Ajan (konuşma)",
  "platform.calls.role.test_agent": "Test ajanı",
  "platform.calls.role.judge": "Görüşme içi denetim",
  "platform.calls.role.bridge": "Dolgu",
  "platform.calls.role.simulator": "Test müşterisi",
  "platform.calls.role.analyst": "Görüşme analizi",
  "eval.title": "Görüşme karnesi (yapay zekâ hakemi)",
  "eval.unsure": "kontrol et",
  "eval.unsureHint": "Hakem bu cevaptan emin değil; dökümden kontrol edin.",
  "eval.score.opening": "Açılış",
  "eval.score.discovery": "İhtiyacı anlama",
  "eval.score.objection_handling": "İtiraz karşılama",
  "eval.score.closing": "Kapanış / sonraki adım",
  "eval.score.clarity": "Netlik ve kısalık",
  "eval.flag.said_recording_notice": "Kayıt bildirimi söylendi",
  "eval.flag.said_ai_disclosure": "Yapay zekâ olduğu söylendi",
  "eval.flag.agent_missed_question": "Soru cevapsız kaldı",
  "eval.flag.agent_repeated": "Ajan tekrar etti",
  "eval.flag.agent_ended_early": "Erken bitirildi",
  "eval.flag.alert_complaint": "Şikâyet / sinirli müşteri",
  "eval.choice.outcome": "Sonuç",
  "eval.choice.loss_reason": "Kayıp nedeni",
  "eval.choice.drop_stage": "Nerede koptu",
  "eval.choice.sentiment_end": "Sondaki ruh hali",
  "eval.choice.outcome.next_step": "Sonraki adım alındı",
  "eval.choice.outcome.callback": "Geri arama",
  "eval.choice.outcome.interested": "İlgili, adım yok",
  "eval.choice.outcome.not_interested": "İlgilenmedi",
  "eval.choice.outcome.opted_out": "Aranmak istemiyor",
  "eval.choice.outcome.no_conversation": "Görüşme olmadı",
  "eval.choice.outcome.unclear": "Belirsiz",
  "eval.choice.loss_reason.price_or_terms": "Fiyat / koşullar",
  "eval.choice.loss_reason.has_provider": "Zaten tedarikçisi var",
  "eval.choice.loss_reason.timing": "Zamanlama",
  "eval.choice.loss_reason.not_decision_maker": "Karar verici değil",
  "eval.choice.loss_reason.no_need": "İhtiyacı yok",
  "eval.choice.loss_reason.distrust": "Güvenmedi",
  "eval.choice.loss_reason.agent_problem": "Ajan kaynaklı",
  "eval.choice.loss_reason.other": "Diğer",
  "eval.choice.loss_reason.not_applicable": "—",
  "eval.choice.drop_stage.opening": "Açılışta",
  "eval.choice.drop_stage.discovery": "İhtiyaç sorularında",
  "eval.choice.drop_stage.presentation": "Tanıtımda",
  "eval.choice.drop_stage.objection": "Soru / itirazda",
  "eval.choice.drop_stage.closing": "Kapanışta",
  "eval.choice.drop_stage.none": "Kopmadı",
  "eval.choice.sentiment_end.positive": "Olumlu",
  "eval.choice.sentiment_end.neutral": "Nötr",
  "eval.choice.sentiment_end.negative": "Olumsuz",
  "eval.questions": "Müşterinin soruları ({a}/{n} cevaplandı)",
  "eval.answered": "Cevaplandı",
  "eval.notAnswered": "Cevapsız",
  "eval.objection": "İtiraz",
  "quality.title": "Görüşme kalitesi",
  "quality.subtitle": "Her görüşme bittikten sonra yapay zekâ hakemi (JEV) değerlendirir: karne, kurallar, sonuç, sorular ve kit kullanımı.",
  "quality.source.real": "Gerçek görüşmeler",
  "quality.source.room": "Test odası",
  "quality.empty": "Bu dönemde değerlendirilmiş görüşme yok.",
  "quality.emptyReal": "Gerçek görüşmeler henüz değerlendirilmiyor (platform yöneticisi açınca başlar). Test odası görüşmelerine bakabilirsiniz.",
  "quality.scorecard": "Karne ortalaması ({n} görüşme)",
  "quality.rules": "Kurallar ve hatalar",
  "quality.lossReasons": "Neden kaybettik",
  "quality.noLoss": "Kayıp yok.",
  "quality.dropStage": "Nerede koptu",
  "quality.questions": "Müşterilerin soruları ({n}, %{p} cevaplandı)",
  "quality.questionsHint": "Cevapsız kalanlar: ajanın bilmediği ya da geçiştirdiği sorular. Cevabı ürün kitine veya İşletme Beyni'ne eklerseniz ajan bir dahakinde cevaplar.",
  "quality.allAnswered": "Tüm sorular cevaplanmış.",
  "quality.openCall": "Görüşmeyi aç",
  "quality.kit": "Ürün kiti kullanımı",
  "quality.kitHint": "Müşterinin sorusu kitteki hangi maddeye denk geldi. Hiç kullanılmayanlar ve cevapsız kalanlar işaretli.",
  "quality.kitItem": "Madde",
  "quality.kitKind": "Tür",
  "quality.kitUsed": "Kullanım",
  "quality.kitUnanswered": "Cevapsız",
  "quality.neverUsed": "hiç",
  "quality.kind.offering": "Ürün",
  "quality.kind.faq": "Sık soru",
  "quality.kind.objection": "İtiraz",
  "voice.engine.title": "Ses kaynağı",
  "voice.engine.hint": "Ajanın sesini hangi sistem üretsin. CenterVoice cevap vermezse cümle otomatik olarak standart sesle söylenir.",
  "voice.engine.standard": "Standart ses (ElevenLabs)",
  "voice.engine.standard.hint": "Ses kütüphanesinden seçim, konuşma hızı ayarı",
  "voice.engine.self_hosted": "CenterVoice",
  "voice.engine.self_hosted.hint": "Kendi ses altyapımız; ses seçimi ve konuşma hızı ayarı",
  "voice.engine.ema": "CenterVoice Türkçe (EMA)",
  "voice.engine.ema.hint": "Kendi Türkçe sesimiz; yalnız Türkçe görüşmelerde. Başka dilde ya da cevap vermezse görüşmenin geri kalanı yedek sesle sürer.",
  "voice.ema.sample": "Türkçe ses örneği",
  "voice.backup.title": "Yedek ses",
  "voice.backup.hint": "Ana ses (EMA ya da kütüphane sesi) bir cümleyi söyleyemezse görüşme bu sesle sürer. Kütüphane sesleri kapalıyken standart ses de budur. Ajanın kendi sesiyle aynı cinsiyette bir ses seçin.",
  "voice.backup.platformDefault": "Platform varsayılanı",
  "platform.calls.estimated": "{n} tahmini",
  "platform.calls.estimatedHint": "\"Tahmini\": ajan cevabı erken hazırlamaya başlayıp müşteri konuşmaya devam edince yarıda bırakılan istekler. Sağlayıcı bunların token sayısını göndermez ama giriş token'larını faturalar; sayı talimat uzunluğundan, aynı görüşmenin ölçülen oranıyla tahmin edildi.",
  "voice.engine.defaultVoice": "Varsayılan ses",
  "platform.calls.warn.voice": "yedek ses {n}×",
  "platform.calls.warn.voiceHint": "Bu görüşmede bazı cümleler ajanın kendi sesiyle değil yedek sesle söylendi (ya da hiç söylenemedi).",
  "platform.calls.warn.silence": "{s} sn sessizlik",
  "platform.calls.warn.silenceHint": "Ajan bir cevaptan önce bu kadar süre sessiz kaldı.",
  "calls.cost.title": "Kullanım ve maliyet (tahmini)",
  "calls.cost.service": "Servis",
  "calls.cost.used": "Ne kullandı",
  "calls.cost.cost": "Tahmini",
  "calls.cost.total": "Toplam",
  "calls.cost.note": "Birim fiyatlardan tahmin, fatura değil. Geliştirme süresince herkes görüyor; sonra yalnız yönetici görecek.",
  "calls.cost.ai": "Yapay zekâ",
  "calls.cost.tts": "Ses (ajanın sesi)",
  "calls.cost.stt": "Dinleme (ses → yazı)",
  "calls.cost.line": "Telefon hattı",
  "calls.cost.tokens": "{calls} çağrı · {in} giriş ({cached} önbellekten) · {out} çıkış token",
  "calls.cost.chars": "{engine} · {chars} karakter · ~{credits} kredi",
  "calls.cost.minutes": "{minutes} dk × {streams} akış",
  "calls.cost.lineMinutes": "{minutes} dk",
  "calls.cost.unpriced": "Fiyatı tanımlı olmayan model: {models}",
  "calls.cost.engine.standard": "ElevenLabs",
  "calls.cost.engine.self_hosted": "CenterVoice",
  "platform.calls.role.decider": "Yapay zekâ hakemi (JEV)",
  "contacts.import.empty": "Satırları yapıştırın ya da CSV dosyası seçin.",
  "contacts.form.title": "Kişi ekle",
  "contacts.form.editTitle": "Kişiyi düzenle",
  "contacts.form.hint": "Ajan aradığı kişinin adını, ünvanını ve şirketini görüşmede kullanır; aramalar kişiye özel olur. Yalnız telefon zorunlu.",
  "contacts.form.save": "Kaydet",
  "contacts.form.cancel": "Vazgeç",
  "contacts.form.edit": "Düzenle",
  "contacts.optional": "isteğe bağlı",
  "contacts.field.name": "Ad Soyad",
  "contacts.field.name.placeholder": "Ör. Ayşe Yılmaz",
  "contacts.field.phone": "Telefon",
  "contacts.field.phone.hint": "Ülke koduyla (+90…). Aynı numara tekrar kaydedilirse bilgileri güncellenir.",
  "contacts.field.title": "Ünvan",
  "contacts.field.title.placeholder": "Ör. Eczacı, Satın alma müdürü",
  "contacts.field.company": "Şirket",
  "contacts.field.city": "Şehir",
  "contacts.field.email": "E-posta",
  "contacts.field.note": "Not",
  "contacts.field.note.hint": "Ajanın bilmesi gereken kısa bilgi (ör. \"geçen ay fiyat sordu\").",
  "call.fromContacts": "Rehberden seç",
  "call.picked": "Seçildi: {name} — ajan bu kişiyi tanıyarak arar.",
  "error.CALL_COUNTRY_NOT_ALLOWED": "Bu ülkedeki numaralar aranamıyor: güvenlik için yalnız hattınızın ülkesindeki numaralar aranabilir. Başka bir ülke gerekiyorsa destekle iletişime geçin.",
  "error.TOO_MANY_ACTIVE_CALLS": "Şu an aynı anda yapılabilecek en fazla görüşme sayısına ulaşıldı. Biri bitince tekrar deneyin.",
  "error.DAILY_CALL_LIMIT": "Bugün panelden başlatılabilecek arama sınırına ulaşıldı. Yarın tekrar deneyin ya da kampanya kullanın.",
  "agent.label.title": "Panel adı",
  "agent.label.placeholder": "Ör. Giden — Farma Tedarik pazarlama ajanı (Türkçe)",
  "agent.label.hint": "Yalnız siz panelde görürsünüz; görüşmede söylenmez.",
  "agent.label.speaking": "Görüşmedeki adı: {name}",
  "agent.label.none": "Panel adı yok.",
  "agent.label.add": "Panel adı ekle",
  "agent.label.edit": "Panel adını değiştir",
  "webcall.start": "Tarayıcıdan konuş",
  "webcall.hint": "Mikrofonla, telefon hattı olmadan; dakika düşmez. Kulaklık önerilir.",
  "webcall.connecting": "Bağlanıyor…",
  "webcall.live": "Görüşmede",
  "webcall.hangup": "Bitir",
  "webcall.error.MIC_DENIED": "Mikrofon izni verilmedi. Tarayıcının adres çubuğundan mikrofona izin verin.",
  "webcall.error.WEB_CALL_CONNECTION": "Ses bağlantısı kurulamadı.",
  "webcall.mute": "Sessize al",
  "webcall.unmute": "Sesi aç",
  "webcall.again": "Yeniden başlat",
  "webcall.close": "Kapat",
  "webcall.status.agent": "Ajan konuşuyor…",
  "webcall.status.user": "Sizi dinliyor",
  "webcall.status.listening": "Dinliyor",
  "webcall.status.muted": "Mikrofonunuz kapalı",
  "webcall.status.ended": "Görüşme bitti",
  "room.mode.sim": "Sanal müşteriyle",
  "room.mode.me": "Ben konuşacağım",
  "room.mode.me.hint": "Ajanla mikrofonunuzla, telefon hattı olmadan konuşun. Görüşme kaydı ve karnesi diğer görüşmeler gibi oluşur; dakika düşmez. Kulaklık önerilir.",
  "webcall.begin": "Görüşmeyi başlat",
  "webcall.section": "Sesli dene (mikrofonla)",
  "webcall.section.text": "Yazarak dene",
  "sms.title": "SMS hesabı",
  "sms.hint": "Ajanın görüşmeden gönderdiği mesajlar (özet, bağlantı) firmanızın kendi SMS hesabından gider; ücret sağlayıcınıza ödenir. Mesajlar yalnız görüşülen numaraya, müşteri isteyince gider.",
  "sms.none": "Bağlı SMS hesabı yok.",
  "sms.connect": "SMS hesabı bağla",
  "sms.provider.verimor": "Verimor SMS",
  "sms.username": "API kullanıcı adı",
  "sms.username.hint": "Verimor'da genellikle 90 ile başlayan hesap numaranız (ör. 908501234567).",
  "sms.password": "API şifresi",
  "sms.password.hint": "Verimor Online İşlem Merkezi → SMS → API ayarlarında belirlediğiniz şifre (giriş şifreniz değil).",
  "sms.sender": "Gönderici başlığı",
  "sms.sender.hint": "Onaylı başlıklarınızdan biri; boş bırakılırsa sağlayıcının varsayılanı kullanılır.",
  "sms.save": "Kontrol et ve kaydet",
  "sms.checking": "Kontrol ediliyor…",
  "sms.saved": "SMS hesabı doğrulandı ve kaydedildi.",
  "sms.removed": "SMS hesabı kaldırıldı.",
  "sms.verified": "Doğrulandı",
  "sms.unverified": "Doğrulanmadı",
  "sms.test": "Deneme SMS'i",
  "sms.test.to": "Numara",
  "sms.test.to.hint": "Uluslararası biçimde, ör. +905xxxxxxxxx",
  "sms.test.text": "Metin",
  "sms.test.send": "Gönder",
  "sms.test.sent": "Deneme SMS'i gönderildi.",
  "sms.parts": "{n} SMS",
  "sms.limits": "Sınırlar: numara başına günde 3, görüşme başına 2.",
  "sms.log.when": "Zaman",
  "sms.log.to": "Numara",
  "sms.log.kind": "Tür",
  "sms.log.status": "Durum",
  "sms.log.text": "Metin",
  "sms.kind.test": "Deneme",
  "sms.kind.summary": "Özet",
  "sms.kind.link": "Bağlantı",
  "sms.status.sent": "Gönderildi",
  "sms.status.failed": "Gönderilemedi",
  "sms.status.refused": "Engellendi",
  "error.SMS_NOT_CONFIGURED": "SMS hesabı bağlı değil.",
  "error.SMS_AUTH": "SMS kullanıcı adı ya da API şifresi yanlış.",
  "error.SMS_BAD_SENDER": "Gönderici başlığı onaylı değil ya da hesabınızda onaylı başlık yok. Başlık, sağlayıcınızın panelinden (ör. Verimor → SMS Hizmeti → Başlıklarım) başvurup onaylandıktan sonra kullanılabilir.",
  "error.SMS_PASSWORD_REQUIRED": "API şifresi gerekli.",
  "error.SMS_NO_CREDIT": "SMS krediniz yetersiz.",
  "error.SMS_TOO_LONG": "Mesaj çok uzun.",
  "error.SMS_EMPTY": "Mesaj boş.",
  "error.SMS_RATE_LIMIT": "Sağlayıcı şu an çok fazla istek alıyor; biraz sonra deneyin.",
  "error.SMS_NUMBER_DAILY_LIMIT": "Bu numaraya bugün izin verilen sayıda SMS gönderildi.",
  "error.SMS_CALL_LIMIT": "Bu görüşme için izin verilen SMS sayısına ulaşıldı.",
  "error.SMS_DAILY_LIMIT": "Bugünkü SMS sınırına ulaşıldı.",
  "error.SMS_PROVIDER_ERROR": "SMS sağlayıcısı isteği reddetti.",
  "error.SMS_PROVIDER_DOWN": "SMS sağlayıcısına ulaşılamadı.",
  "wa.title": "WhatsApp",
  "wa.hint": "Ajanın görüşmeden gönderdiği mesajlar (özet, bağlantı) firmanızın kendi WhatsApp Business hesabından, Meta'da onaylı şablonlarla gider. Yalnız görüşülen numaraya, müşteri isteyince.",
  "wa.none": "Bağlı WhatsApp hesabı yok.",
  "wa.connect": "WhatsApp bağla",
  "wa.where": "Bilgiler Meta for Developers → uygulamanız → WhatsApp → API Kurulumu sayfasında.",
  "wa.phoneNumberId": "Telefon numarası kimliği",
  "wa.phoneNumberId.hint": "\"Phone number ID\" — yalnız rakamlar.",
  "wa.wabaId": "WhatsApp İşletme Hesabı kimliği",
  "wa.wabaId.hint": "\"WhatsApp Business Account ID\" — yalnız rakamlar.",
  "wa.token": "Erişim anahtarı",
  "wa.token.hint": "Kalıcı anahtar için Meta İşletme Ayarları → Sistem kullanıcıları. Geçici anahtar 24 saatte biter.",
  "wa.language": "Dil",
  "wa.language.hint": "Şablonların varsayılan dili, ör. tr, en, ar.",
  "wa.saved": "WhatsApp hesabı doğrulandı ve kaydedildi.",
  "wa.removed": "WhatsApp hesabı kaldırıldı.",
  "wa.templates.count": "{n} onaylı şablon (toplam {all})",
  "wa.templates.unknown": "Şablonlar şu an alınamadı.",
  "wa.template": "Şablon",
  "wa.category": "Tür",
  "wa.template.none": "Onaylı şablon yok; WhatsApp Manager → Mesaj şablonları'ndan ekleyin.",
  "wa.params": "Değerler",
  "wa.params.hint": "Şablondaki {{1}}, {{2}}… sırasıyla; | ile ayırın. Değişkensiz şablonda boş bırakın.",
  "wa.test": "Deneme mesajı",
  "wa.test.to.hint": "Deneme numarasıyla yalnız Meta'da kayıtlı alıcılara (en çok 5) gider.",
  "wa.test.sent": "WhatsApp mesajı gönderildi.",
  "error.WHATSAPP_NOT_CONFIGURED": "WhatsApp hesabı bağlı değil.",
  "error.WA_AUTH": "Erişim anahtarı geçersiz ya da süresi dolmuş.",
  "error.WA_BAD_ID": "Kimlikler yalnız rakam olmalı.",
  "error.WA_TOKEN_REQUIRED": "Erişim anahtarı gerekli.",
  "error.WA_RECIPIENT_NOT_ALLOWED": "Bu numara deneme numarasının alıcı listesinde yok (Meta → API Kurulumu → \"To\" listesine ekleyin).",
  "error.WA_TEMPLATE_UNKNOWN": "Şablon bulunamadı.",
  "error.WA_TEMPLATE_NOT_APPROVED": "Şablon bu dilde onaylı değil.",
  "error.WA_TEMPLATE_PARAMS": "Şablon değerleri eksik ya da fazla.",
  "error.WA_WINDOW_CLOSED": "Serbest mesaj yalnız müşteri son 24 saatte yazdıysa gider; şablon kullanın.",
  "error.WA_UNDELIVERABLE": "Mesaj bu numaraya iletilemedi (WhatsApp kullanmıyor olabilir).",
  "error.WA_RATE_LIMIT": "WhatsApp gönderim sınırına ulaşıldı; biraz sonra deneyin.",
  "error.WA_PROVIDER_ERROR": "Meta isteği reddetti.",
  "error.WA_PROVIDER_DOWN": "Meta'ya ulaşılamadı.",
  "wa.host.none": "Panaryus'ta bağlı WhatsApp numarası yok. Numaranızı Panaryus'ta bir kez bağlayın; ajan mesajları oradan gönderir, müşteri cevapları Panaryus gelen kutusuna düşer.",
  "wa.host.connect": "Panaryus'ta WhatsApp bağla",
  "wa.host.manage": "Panaryus'ta yönet",
  "wa.host.managed": "Panaryus'ta bağlı numara — cevaplar Panaryus gelen kutusunda.",
  "error.WA_HOST_UNREACHABLE": "Panaryus'a ulaşılamadı.",
  "error.WHATSAPP_MANAGED_BY_HOST": "WhatsApp Panaryus'ta yönetiliyor.",
  "error.PRINCIPAL_NOT_FOUND": "Panaryus hesabı bulunamadı.",
  "compliance.title": "Yasal açıklamalar",
  "compliance.item.ai_disclosure": "Yapay zekâ olduğunu söyledi",
  "compliance.item.recording_notice": "Kayıt bildirimini yaptı",
  "compliance.item.business_identity": "Ticaret unvanını söyledi",
  "compliance.late": "süresinden geç",
  "compliance.missing": "söylenmedi",
  "error.PERMISSION_DENIED": "Bu işlem için yetkiniz yok. Takım sahibinden ya da yöneticiden izin isteyin.",
  "error.NOT_A_MEMBER": "Bu çalışma alanına erişiminiz yok.",
  "error.ACCESS_UNAVAILABLE": "Yetkileriniz şu an doğrulanamadı; biraz sonra tekrar deneyin.",
  "error.ROUTE_NOT_CLASSIFIED": "Bu işlem şu an kapalı.",
  "error.VOICE_TURKISH_ONLY": "Bu ses yalnız Türkçe konuşur; bu ajanın dili farklı.",
  "access.readOnly": "Yalnız görüntüleme. Değiştirmek için “{name}” yetkisi gerekir; takım sahibinden ya da yöneticiden isteyin.",
  "access.noPage": "Bu sayfaya erişiminiz yok. “{name}” yetkisi gerekir; takım sahibinden ya da yöneticiden isteyin.",
  "access.perm.centeros.view": "Görüşmeleri ve istatistikleri görme",
  "access.perm.centeros.recordings": "Kayıtlar ve tam dökümler",
  "access.perm.centeros.call": "Arama ve test odası",
  "access.perm.centeros.contacts": "Rehber ve aranmayacaklar listesi",
  "access.perm.centeros.campaigns": "Kampanyalar",
  "access.perm.centeros.agents": "Ajanlar (oluşturma, düzenleme, yayınlama)",
  "access.perm.centeros.lines": "Telefon hatları ve mesajlaşma",
  "access.perm.centeros.compliance": "Gizlilik ve işlem kayıtları",
  "nav.audit": "İşlem kayıtları",
  "audit.title": "İşlem kayıtları",
  "audit.subtitle": "Panelde kim, ne zaman, ne yaptı: değişiklikler, dinlenen kayıtlar ve reddedilen denemeler. İçerik yazılmaz; kayıtlar silinemez.",
  "audit.empty": "Henüz kayıt yok.",
  "audit.when": "Zaman",
  "audit.who": "Kim",
  "audit.what": "İşlem",
  "audit.on": "Hedef",
  "audit.result": "Sonuç",
  "audit.more": "Daha eskiler",
  "audit.res.ok": "Yapıldı",
  "audit.res.denied": "Yetki yok",
  "audit.res.failed": "Hata",
  "audit.verb.POST": "ekleme/işlem",
  "audit.verb.PUT": "değiştirme",
  "audit.verb.PATCH": "değiştirme",
  "audit.verb.DELETE": "silme",
  "audit.verb.GET": "görüntüleme",
  "audit.area.agents": "Ajan",
  "audit.area.calls": "Görüşme",
  "audit.area.contacts": "Rehber",
  "audit.area.do-not-call": "Aranmayacaklar",
  "audit.area.campaigns": "Kampanya",
  "audit.area.telephony": "Telefon hattı",
  "audit.area.sms": "SMS hesabı",
  "audit.area.whatsapp": "WhatsApp",
  "audit.area.templates": "Şablon",
  "audit.area.studio": "Stüdyo",
  "audit.area.test-rooms": "Test odası",
  "audit.area.previews": "Ön izleme",
  "audit.action.POST /v2/api/agents/:id/publish": "Ajan yayınlandı",
  "audit.action.PUT /v2/api/agents/:id/spec": "Ajan ayarları değişti",
  "audit.action.POST /v2/api/agents/:id/calls": "Arama başlatıldı",
  "audit.action.POST /v2/api/agents/:id/web-calls": "Tarayıcıdan görüşme",
  "audit.action.GET /v2/api/calls/:id/recording": "Ses kaydı dinlendi",
  "audit.action.POST /v2/api/do-not-call": "Aranmayacaklara eklendi",
  "audit.action.DELETE /v2/api/do-not-call/:e164": "Aranmayacaklardan çıkarıldı",
  "audit.action.POST /v2/api/contacts/import": "Rehber içe aktarıldı",
  "audit.action.DELETE /v2/api/contacts/:id": "Rehberden kişi silindi",
  "audit.action.POST /v2/api/campaigns": "Kampanya oluşturuldu",
  "audit.action.POST /v2/api/campaigns/:id/:action": "Kampanya başlatıldı/durduruldu",
  "audit.action.POST /v2/api/test-rooms": "Test odası görüşmesi",
  "nav.privacy": "Veri ve gizlilik",
  "privacy.title": "Veri ve gizlilik",
  "privacy.subtitle": "Görüşmelerin kişisel verilerinin ne kadar saklanacağı. Süresi dolanlar her gece kendiliğinden silinir.",
  "privacy.retention": "Saklama süreleri",
  "privacy.retention.hint": "Her biri {min}–{max} gün. Kişisel veriler gerektiğinden uzun saklanmamalıdır (KVKK); süreleri hukuk danışmanınızla belirleyin.",
  "privacy.recordings": "Ses kayıtları (gün)",
  "privacy.recordings.hint": "Önerilen: {n} gün. Süresi dolan kayıt depodan silinir.",
  "privacy.transcripts": "Görüşme metinleri ve özetler (gün)",
  "privacy.transcripts.hint": "Önerilen: {n} gün. Konuşma metni, özet, toplanan bilgiler ve müşterinin sözleri silinir.",
  "privacy.messages": "Gönderilen mesajlar (gün)",
  "privacy.messages.hint": "Önerilen: {n} gün. SMS/WhatsApp metinleri silinir.",
  "privacy.kept": "Silinmeden kalanlar: görüşmenin tarihi ve süresi, puanı, sonucu, yasal açıklamaların zamanı ve maliyet — istatistikler bozulmaz. Aranmayacaklar listesi silinmez.",
  "privacy.save": "Kaydet",
  "privacy.saved": "Saklama süreleri kaydedildi.",
  "privacy.updated": "Son değişiklik: {at}",
  "privacy.usingDefaults": "Önerilen süreler kullanılıyor.",
  "privacy.callPurged": "Bu görüşmenin kaydı ve/veya metni saklama süresi dolduğu için {at} tarihinde silindi.",
  "privacy.erase.title": "Kişisel veri silme talebi",
  "privacy.erase.hint": "Bir kişi verilerinin silinmesini istediğinde: o numaraya ait ses kayıtları silinir; görüşme metinleri, özetler, mesajlar ve kampanya kayıtlarındaki ad/numara silinir; rehber kaydı kaldırılır. Bu çalışma alanıyla sınırlıdır.",
  "privacy.erase.phone": "Telefon numarası",
  "privacy.erase.dnc": "Bir daha aranmaması için aranmayacaklar listesine ekle (yalnız numara tutulur)",
  "privacy.erase.button": "Verileri kalıcı olarak sil",
  "privacy.erase.warn": "Geri alınamaz. İşlem kayıtlarına yazılır.",
  "privacy.erase.done": "Silindi: {calls} görüşme, {recordings} ses kaydı, {messages} mesaj, {contacts} rehber kaydı.",
  "privacy.iys.title": "İYS kontrolü",
  "privacy.iys.hint": "Ticari aramadan önce numaranın İYS izni sorulur. Cevap birkaç gün saklanır; bu sürede aynı numara için yeniden sorgu atılmaz. İzni olmayan numara aranmaz (kampanya raporunda \"İYS izni yok\" yazar). \"Aramayın\" diyen kişinin saklı cevabı geçersiz olur. Bilgilendirme amaçlı ajanlar kontrol edilmez.",
  "privacy.iys.enabled": "Ticari aramadan önce İYS izni sorulsun",
  "privacy.iys.days": "Cevap saklama süresi (gün)",
  "privacy.iys.days.hint": "0–30 gün, önerilen 7. 0 = her aramada yeniden sorulur.",
  "privacy.iys.skipBusiness": "Rehberde \"işletme\" olarak işaretli numaralarda İYS sorgusunu atla",
  "privacy.iys.skipBusiness.hint": "Bu kural genel bilgiye dayanıyor, avukat teyidi bekliyor; bu yüzden kapatılabilir. Kapatılırsa işletme numaraları da (tacir olarak) sorgulanır. \"Bilinmiyor\" işaretli numaralar şahıs gibi sorgulanır.",
  "privacy.iys.noProvider": "İYS sağlayıcısı henüz bağlı değil; kontrol açılamaz. Bağlandığında sorgu başı ücret: {price} ₺.",
  "privacy.iys.mock": "Deneme sağlayıcısı bağlı: cevaplar sahte ve ücretsiz, gerçek İYS'ye sorulmuyor.",
  "privacy.iys.provider": "Sağlayıcı: {name} · sorgu başı {price} ₺",
  "privacy.iys.stats": "Bu ay ({month})",
  "privacy.iys.stats.queries": "Atılan sorgu",
  "privacy.iys.stats.cached": "Saklanan cevaptan dönen",
  "privacy.iys.stats.business": "İşletme numarası (sorgusuz)",
  "privacy.iys.stats.spent": "Harcanan",
  "privacy.iys.money": "{amount} ₺",
  "privacy.iys.defaults": "Varsayılan ayarlar: kontrol kapalı, 7 gün, işletmede atla.",
  "privacy.iys.saved": "İYS ayarları kaydedildi.",
  "settings.legal": "Yasal bilgiler",
  "settings.legal.hint": "Ticari aramalarda arayan firmanın kimliği ve aramanın amacı.",
  "field.identity.legalName": "Ticaret unvanı",
  "field.identity.legalName.hint": "Doldurulursa ajan açılışta bu unvanı söylemek zorundadır ve görüşme kartında kanıtı görünür.",
  "field.callPurpose": "Arama amacı",
  "field.callPurpose.hint": "Ticari aramalarda, bağlıysa İYS izni aramadan önce kontrol edilir.",
  "field.callPurpose.commercial": "Ticari (tanıtım, satış)",
  "field.callPurpose.informational": "Bilgilendirme (randevu, hatırlatma, işlem)",
  "settings.consent.notConnected": "İYS kontrolü henüz bağlı değil: ticari aramalarda numaranın izni kontrol edilmiyor. Bireylere ticari arama yapmadan önce izin durumunu kendiniz doğrulayın.",
  "error.CONSENT_REFUSED": "Bu numara İYS'de ticari aramaya izin vermiyor.",
  "error.CONSENT_UNKNOWN": "Bu numaranın İYS izni bilinmiyor; ayarlara göre aranmadı.",
  "error.IYS_NO_CONSENT": "İYS izni yok",
  "error.IYS_PROVIDER_MISSING": "İYS sağlayıcısı bağlı değil.",
  "error.IYS_CHECK_FAILED": "İYS sorgusu yapılamadı.",
  "error.BACKUP_VOICE_UNKNOWN": "Bu yedek ses sunulmuyor; listeden bir ses seçin.",
  "error.CALL_HAS_NO_NUMBER": "Bu görüşmede kaydedilebilecek bir telefon numarası yok.",
  "error.HOURS_INVALID": "Çalışma saatleri geçersiz.",
  "error.INBOUND_AGENT_REQUIRED": "Önce bu numaraya gelen aramayı cevaplayan ajanı seçin.",
  "error.CLOSED_MESSAGE_FAILED": "Mesaj seslendirilemedi; biraz sonra yeniden kaydedin.",
  "calls.tab.web": "Web sohbetleri",
  "web.empty": "Henüz web sohbeti yok. Sitenize kit eklendiğinde ziyaretçi sohbetleri burada görünür.",
  "web.pick": "Bir sohbet seçin.",
  "web.messages": "{n} mesaj",
  "web.collected": "Ajanın topladığı bilgiler",
  "web.request": "Ekibe iletilen konu",
  "web.page": "Son sayfa",
  "web.ended": "Bitti",
  "web.open": "Açık",
  "web.visitor": "Ziyaretçi",
  "web.agent": "Ajan",
  "web.noFacts": "Henüz bilgi toplanmadı.",
  "web.site": "Site",
  "calls.party.webChat": "Web sohbeti",
  "web.report": "Görüşme raporu",
  "web.report.none": "Bu sohbet rapor özelliğinden önce başladı; raporu yok.",
  "web.report.pending": "Rapor hazırlanıyor (sohbet bittikten sonra bir dakika içinde).",
  "web.report.afterEnd": "Rapor sohbet bitince hazırlanır (ziyaretçi bitirince ya da 2 saat hareketsizlikte).",
  "web.openCall": "Görüşme kartını aç (maliyet, değerlendirme)"
}
